import React, { Fragment, useEffect, useState } from "react";
import { Row, Container, Col } from "reactstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { checkForNull, checkForNullNegative } from "../../helper/validation";
import { Loader, } from "../common/Loader";
import { reactLocalStorage } from "reactjs-localstorage";
import { StemMaterialData } from "../../config/masterData";
import { loggedInUserId } from "../../helper/auth";
import { useForm } from "react-hook-form";
import TeInput from "../forms/TeInput";
import TeSelect from "../forms/TeSelect";
import {
  saveElectricalData,
  getElectricShutterData,
  updateElectricGate,
} from "../../actions/DesignMaster";
import $ from "jquery";
import moment from "moment";
import { onKeyPress } from "../../config/config";
import TooltipCustom from "../common/TooltipCustom";
import SearchableSelect from "../forms/SearchableSelect";

const embededLengthConcreteOptions = [
  { label: "75", Value: 75 },
  { label: "90", Value: 90 },
  { label: "100", Value: 100 },
  { label: "110", Value: 110 },
  { label: "125", Value: 125 },
  { label: "150", Value: 150 },
  { label: "200", Value: 200 },
  { label: "250", Value: 250 },
];

const actuatorGearBoxData = [
  { label: "Actuator with Gear Box.", value: "WITH-GEAR-BOX" },
  { label: "Actuator without Gear Box.", value: "WITHOUT-GEAR-BOX" },
];

const SeriesOfferedOption = [

  { Text: 'A-101- FLAT BACK FRAME DESIGN', Value: 'A-101- FLAT BACK FRAME DESIGN', Key: '1' },
  { Text: 'A-102- SECTIONAL FRAME DESIGN', Value: 'A-102- SECTIONAL FRAME DESIGN', Key: '1' },
  { Text: 'A-103- INTEGRAL FRAME DESIGN', Value: 'A-103- INTEGRAL FRAME DESIGN', Key: '1' },
  { Text: 'A-104- UNIVERSAL FRAME DESIGN', Value: 'A-104- UNIVERSAL FRAME DESIGN', Key: '1' },
  { Text: 'A-111', Value: 'A-111', Key: '1' },
  { Text: 'A-112', Value: 'A-112', Key: '1' },
  { Text: 'A-113', Value: 'A-113', Key: '1' },
  { Text: 'A-113-B', Value: 'A-113-B', Key: '1' },
  { Text: 'A-114', Value: 'A-114', Key: '1' },
  { Text: 'A-121', Value: 'A-121', Key: '1' },



  { Text: 'A-201-202-203 CAST IRON OPEN CHANNEL', Value: 'A-201-202-203 CAST IRON OPEN CHANNEL', Key: '2' },
  // { Text: "A-211", Value: "A-211", Key: '2' },
  // { Text: "A-212", Value: "A-212", Key: '2' },
  // { Text: "A-213", Value: "A-213", Key: '2' },
  // { Text: "A-221", Value: "A-221", Key: '2' },
  // { Text: "A-222", Value: "A-222", Key: '2' },
  // { Text: "A-223", Value: "A-223", Key: '2' },
  { Text: 'A-211 / 212 / 213', Value: 'A-211 / 212 / 213', Key: '2' },
  { Text: 'A-221 / 222 / 223', Value: 'A-221 / 222 / 223', Key: '2' },
  { Text: 'A-301 CAST IRON WEIR GATE', Value: 'A-301 CAST IRON WEIR GATE', Key: '3' },
  { Text: 'A-311', Value: 'A-311', Key: '3' },
  { Text: 'A-321', Value: 'A-321', Key: '3' },

  // { Text: 'A-113/A-113-B/A-114', Value: 'A-113/A-113-B/A-114' },
  // { Text: 'A-211/212/213 & A-221/222/223', Value: 'A-211/212/213 & A-221/222/223' },
  // { Text: 'A-311 & 321', Value: 'A-311 & 321' },



]

const stemDiameterOptions = [
  { label: 25, value: 25 },
  { label: 30, value: 30 },
  { label: 35, value: 35 },
  { label: 40, value: 40 },
  { label: 45, value: 45 },
  { label: 50, value: 50 },
  { label: 55, value: 55 },
  { label: 60, value: 60 },
  { label: 65, value: 65 },
  { label: 70, value: 70 },
  { label: 75, value: 75 },
  { label: 80, value: 80 },
  { label: 85, value: 85 },
  { label: 90, value: 90 },
  { label: 95, value: 95 },
  { label: 100, value: 100 },
  { label: 105, value: 105 },
  { label: 110, value: 110 },
  { label: 115, value: 115 },
  { label: 120, value: 120 },
  { label: 130, value: 130 },
  { label: 140, value: 140 },
  { label: 150, value: 150 },
  { label: 160, value: 160 },
]

const hoistingCapacityPercentage = [
  { label: "1.25", value: 1.25, percent: 25 },
  { label: "1.33", value: 1.33, percent: 33 },
  { label: "1.50", value: 1.50, percent: 50 },
]

const thicknessDropdown1 = [
  { label: "4", value: 4 },
  { label: "6", value: 6 },
]
const thicknessDropdown2 = [
  { label: "5", value: 5 },
  { label: "6", value: 6 },
]
const thicknessDropdown3 = [
  { label: "6", value: 6 },
]
const ElectricallyGates = ({
  data,
  shutterDesignData,
  getElectricShutterData,
  updateElectricGate,
  saveElectricalData,
  toggle,
  isEditFlag,
  ShutterId,
  setHoistingCapacity,
  tab,
  setCriticalBulkingForceValue,
  setWidth,
  isViewFlag,
  electricalDesignCreated,
  setElectricDesignCreated,
  ...props }) => {

  // const { stemMaterial } = shutterDesignData;
  const {
    height,
    seatingHead,
    unseatingHead,
    width,
    cl_pl,
    shaftSpindle,
    frameMounting,
    ClosureType,
    SelectedSeriesOffered,
    skinPlateThickness,
    client,
    project,
    location,
    tag_number,
    rev_number,
    rev_date,
    date,
    selectedThrustOn,
    SelectedFrameLengthType,
    stemMaterial,
  } = data


  let thicknessOfSkinPlate = parseInt(skinPlateThickness);
  const isSelectedThrustOnIsFrame = selectedThrustOn === "FRAME" ? true : false
  const noWeightOfDoor = SelectedSeriesOffered === 'A-111' || SelectedSeriesOffered === 'A-112';
  const [isLoader, setLoader] = useState(false);
  const [weightOfDoor, setWeightOfDoor] = useState(0);
  const [embededLengthConcrete, setEmbededLengthConcrete] = useState(0);
  const [unsupportedLengthForUnthreadedStem, setUnsupportedLengthForUnthreadedStem] = useState(0);
  const [electricOperationId, setElectricOperationId] = useState('');
  const [cofficientOfFriction, setCofficientOfFriction] = useState('');
  const [numberOfStarts, setNumberOfStarts] = useState(0);
  const [selectedGearboxModel, setSelectedGearboxModel] = useState('');
  const [selectedGearRatio, setSelectedGearRatio] = useState(1);
  const [selectedCrankRadius, setSelectedCrankRadius] = useState(0);
  const [typeOfOperation, setTypeOfOperation,] = useState('');
  const [unsupportedLength, setUnsupportedLength] = useState(0);
  const [unsupportedLengthThreaded, setUnsupportedLengthThreaded] = useState(0);
  const [diaOfBolts, setDiaOfBolts] = useState(0);
  const [materialOfConstruction, setMaterialOfConstruction] = useState('Stainless Steel');
  const [quantityOfFastenrs, setQuantityOfFastenrs] = useState(0);
  const [materialOfSelectedBolt, setMaterialOfSelectedBolt] = useState('Stainless Steel');
  const [diameterOfBolt, setDiameterOfBolt] = useState(0);
  const [lengthOfBolt, setLengthOfBolt] = useState(0);
  const [quantityOfBoltOnPillar, setQuantityOfBoltOnPillar] = useState(0);
  const [onSeatingLessThan6Leakae, setOnSeatingLessThan6Leakae] = useState(0);
  const [onOffSeatingLessThan6Leakae, setOnOffSeatingLessThan6Leakae] = useState(0);
  const [onSeatingMoreThan6Leakae, setOnSeatingMoreThan6Leakae] = useState(0);
  const [onOffSeatingMoreThan6Leakae, setOnOffSeatingMoreThan6Leakae] = useState(0);
  const [constructionMaterialOfYoke, setConstructionMaterialOfYoke] = useState('');
  const [youkeSection, setYokeSection] = useState('B');
  const [thicknessOfSection, setThicknessOfSection] = useState(0);
  const [selectedActuatorGearBox, setSelectedActuatorGearBox] = useState('');
  const [gearBoxStemAcceptance, setGearBoxStemAcceptance] = useState(0);
  const [gearBoxStemMaxAcceptance, setGearBoxStemMaxAcceptance] = useState(0);
  const [gearBoxMaxThrustCapacity, setgearBoxMaxThrustCapacity] = useState(0);
  const [gearBoxMaxTorqueCapacity, setgearBoxMaxTorqueCapacity] = useState(0);
  const [gearBoxOutputDiameter, setgearBoxOutputDiameter] = useState(0);
  const [gearBoxRatio, setgearBoxRatio] = useState(0);
  const [gearBoxMechanicalAdvantage, setgearBoxMechanicalAdvantage] = useState(0);
  //const [selectedFBCData, setSelectedFBCData] = useState('');
  const [availTimeOpenGate, setavailTimeOpenGate] = useState(0);
  const [actuatorModelRPM, setactuatorModelRPM] = useState(0);
  const [actuatorTorqueRPM, setactuatorTorqueRPM] = useState(0);
  const [maximumThrustCapacityAcuator, setmaximumThrustCapacityAcuator] = useState(0);
  const [spindleAcceptanceActuatorModel, setspindleAcceptanceActuatorModel] = useState(0);
  const [gearRatioBetweenBevelActuator, setgearRatioBetweenBevelActuator] = useState(0);
  const [mechanicalEfficiencyBevel, setmechanicalEfficiencyBevel] = useState(0);
  const [actuatorHandwheelRadius, setactuatorHandwheelRadius] = useState(0);
  const [stallTorque, setstallTorque] = useState(0);
  const [acutatorSpeed, setAcutatorSpeed] = useState(0);
  const [standard, setStandard] = useState('');
  const [lengthOfColoum, setLengthOfColoum] = useState(0);
  const [onseatingHeadLessThan6Value, setOnseatingHeadLessThan6Value] = useState(0);
  const [onOffSeatingHeadLessThan6Value, setonOffSeatingHeadLessThan6Value] = useState(0);
  const [onseatingHeadMoreThan6Value, setOnseatingHeadMoreThan6Value] = useState(0);
  const [onOffSeatingHeadMoreThan6Value, setOnOffseatingHeadMoreThan6Value] = useState(0);
  const [valueOfLSection11, setValueOfLSection11] = useState(0)
  const [actuatorModelSelected, setActuatorModelSelected] = useState('');
  const [distanceBetweenSpindleGuides, setDistanceBetweenSpindleGuides] = useState(0);
  const [slideSluiceGateStandard, setSlideSluiceGateStandard] = useState('')
  const [lengthOfBoltOfWallTimble, setLengthOfBoltOfWallTimble] = useState(0);
  const [actuatorModel, setActuatorModel] = useState('');
  const [factorOfSafetyElectrical, setFactorOfSafetyElectrical] = useState('STANDARD');
  const [factorOfSafetyCustomValue, setFactorOfSafetyCustomValue] = useState(0);
  const [stemDiameterDD, setStemDiameterDD] = useState('');
  const [frameExtensionValue, setFrameExtensionValue] = useState('');
  const [frameLengthValue, setFrameLengthValue] = useState(0);
  const [ciShutter, setCIShutter] = useState(false);
  const [hoistingCapacityPercent, setHoistingCapacityPercent] = useState(0);
  const [thicknessValue, setThicknessValue] = useState(0);
  // const weigth = noWeightOfDoor ? parseFloat(weightOfDoor) : weightDoor(data)
  const weigth = parseFloat(weightOfDoor);
  const intWidth = width ? parseFloat(width) : 0;
  const intHeight = height ? parseFloat(height) : 0;
  const intSeatingHead = seatingHead ? parseFloat(seatingHead) : 0;
  const intUnseatingHead = unseatingHead ? parseFloat(unseatingHead) : 0;
  const intStemDia = stemDiameterDD ? checkForNull(stemDiameterDD) : 0;
  const intCL_PL = cl_pl ? parseFloat(cl_pl) : 0;
  const intUTS = shutterDesignData.UTS ? parseFloat(shutterDesignData.UTS) : 0
  const finishedDiaOfSpindle = intStemDia < 91 ? intStemDia : intStemDia - 2
  const finishedDiaOfSpindleDividedByThousand = finishedDiaOfSpindle / 1000
  const additionalLengthOfSpindle = 1200;
  const diameterOfSpindle = intStemDia;
  const distanceBetweenCLPL = intCL_PL * 1000
  const totalLengthOfSpindle = distanceBetweenCLPL + additionalLengthOfSpindle;
  const densityOfSewage = 1010;
  const gravity = 9.81
  const frictionCofficient = 0.15;
  const maximumThrustCapacity = selectedGearboxModel === 'OTHER' ? '-' : 21
  const maximumEffortByOperator = 178;
  const effortByOperatorDividedByGravity = maximumEffortByOperator / gravity;
  const maximumTorqueByOperator = checkForNull(effortByOperatorDividedByGravity * selectedCrankRadius);
  const gearEfficiency = 0.85;
  const youngsModulusOfElasticity = 200000;
  const endConditionConstant = 2.00;
  const staticFrictionCoefficient = 0.180;
  const dynamicFrictionCoefficient = 0.130;
  const heightInMeter = intHeight / 1000;
  const widthInMeter = intWidth / 1000;
  const momentOfInertia = 19278317;
  let hoistingCapacityValue = ''
  let criticalBulkingForceValue = 0
  const validValues = [150, 200, 250, 300, 400, 450, 500, 600];
  const dimensions = validValues.includes(intWidth) && validValues.includes(intHeight);
  const validValues2 = [1200]
  const dimensions2 = validValues2.includes(intWidth) && validValues2.includes(intHeight);
  const {
    register,
    handleSubmit,
    errors,
    setValue
  } = useForm();

  useEffect(() => {
    let ciDropDown

    $('html, body').animate({ scrollTop: 0 }, 800);
    //Get Manual Gates data
    setLoader(true)
    if (isEditFlag || isViewFlag || ShutterId) {
      getElectricShutterData(ShutterId, (res) => {
        //
        if (res && res.data && res.data.Result) {
          let Data = res.data.Data;

          setElectricOperationId(Data.ElectricalOperationGateCalculationId)
          //1
          setCofficientOfFriction(Data.FrictionCoefficient);
          //3 A
          setNumberOfStarts(Data.NumberOfStarts);
          //3 C
          setSelectedActuatorGearBox(Data.SelectedActuatorType)
          setGearBoxStemAcceptance(Data.RequiredStemAcceptanceForGearBoxAfterTurning)
          setSelectedGearboxModel(Data.GearBoxModelSelected)
          setGearBoxStemMaxAcceptance(Data.MaximumStemAcceptanceOfSelectedGearBox)
          setgearBoxMaxThrustCapacity(Data.MaximumThrustCapacityOfSelectedGearBox)
          setgearBoxMaxTorqueCapacity(Data.MaximumTorqueCapacityOfSelectedGearBox)
          setgearBoxOutputDiameter(Data.OutPutDiameterOfSelectedGearBox)
          setgearBoxRatio(Data.GearRatioOfSelectedGearBox)
          setgearBoxMechanicalAdvantage(Data.MechanicalAdvantageOfGearBox)
          setavailTimeOpenGate(Data.TimeAvailableToOpenTheGate)
          setActuatorModel(Data.ActuatorModelSelected) // Above to 'RPM of selected actuator model'
          setactuatorModelRPM(Data.RPMOfSelectedActuatorModel)
          setactuatorTorqueRPM(Data.ActuatorRatedTorqueAtGivenRPM)
          setmaximumThrustCapacityAcuator(Data.MaximumThrustCapacityOfSelectedActuatorModel) //Below to 'Actuator rated torque at this RPM'    
          setspindleAcceptanceActuatorModel(Data.SpindleAcceptanceOfSelectedActuatorModel)
          setActuatorModelSelected(Data.ActuatorModelSelectedIs) //this field 'Hence, Actuator model selected is'
          //3 D
          setgearRatioBetweenBevelActuator(Data.GearRatioBetweenBevelGearAndActuatorHandwheel)
          setmechanicalEfficiencyBevel(Data.MechanicalEfficiencyOfBevel)
          setactuatorHandwheelRadius(Data.HandwheelRadiusOfSelectedActuator)
          //3 E
          setstallTorque(Data.StallTorque)
          //4
          setStandard(Data.SelectedAbilityOfSpindle)
          setLengthOfColoum(checkForNull(Data.LengthOfColumnBetween2GuidesWorstCase))
          //5
          setDistanceBetweenSpindleGuides(Data.lengthOfColoum)
          //7
          setAcutatorSpeed(Data.ActuatorSpeed)
          //8
          setMaterialOfConstruction(Data.SelectedMaterialOfConstructionWallThimble)
          setQuantityOfFastenrs(Data.QuantityOfFastenersWallThimble)
          setDiaOfBolts(Data.SelectedDiameterOfBoltsWallThimble)
          setLengthOfBoltOfWallTimble(Data.SelectedLengthOfBoltsWallThimble)
          setEmbededLengthConcrete(Data.SelectedLengthOfBoltsWallThimble)
          //9
          // setMaterialOfSelectedBolt(Data.SelectedMaterialOfBoltForYoke)
          // setDiameterOfBolt(Data.SelectedDiameterOfBoltsForYoke)
          // setLengthOfBolt(Data.SelectedLengthOfBoltsForYoke)
          // setQuantityOfBoltOnPillar(Data.QuantityOfBoltOnPillarForYoke)
          //10
          handleChange(Data.SelectedSlideOrSluiceGateStandard)
          setOnSeatingLessThan6Leakae(Data.MaxAllowableLeakageSeatingHeadLessThan6M)
          setOnOffSeatingLessThan6Leakae(Data.MaxAllowableLeakageOffSeatingHeadLessThan6M)
          setOnSeatingMoreThan6Leakae(Data.MaxAllowableLeakageSeatingHeadMoreThan6M)
          setOnOffSeatingMoreThan6Leakae(Data.MaxAllowableLeakageOffSeatingHeadMoreThan6M)
          //11
          setConstructionMaterialOfYoke(Data.SelectedMaterialOfConstructionYoke)
          setYokeSection(Data.SelectedYokeSection)
          setThicknessOfSection(Data.SelectedYokeThickness)
          setValueOfLSection11(Data.LengthForAllowableDeflection)
          setMaterialOfSelectedBolt(Data.SelectedMaterialOfBoltForYoke);
          setDiameterOfBolt(Data.SelectedDiameterOfBoltsForYoke);
          setLengthOfBolt(Data.SelectedLengthOfBoltsForYoke);
          setQuantityOfBoltOnPillar(Data.QuantityOfBoltOnPillarForYoke);
          setWeightOfDoor(Data.DoorWeight);
          setUnsupportedLengthForUnthreadedStem(checkForNull(Data.UnsupportedLengthForUnthreadedStemSection))

          setFactorOfSafetyElectrical(Data.SelectedFactorOfSafetyElectrical)     // API change
          setFactorOfSafetyCustomValue(Data.FactorOfSafetyCustomValue)     // API change
          setFrameExtensionValue(Data.SelectedFrameExtension)
          setFrameLengthValue(Data.FrameLength)
          setStemDiameterDD(Data.SelectTypicalHorizontalRIB === 'WITH STEM HOLE' ? Data.SelectedStemDiameter : Data.SelectedStemDiameterElectrical)
          setThicknessValue({ label: Data.DoorThickness, value: Data.DoorThickness })
          setHoistingCapacityPercent({ label: Data.ReserveCapacity, value: Data.ReserveCapacity })
          if ((Data.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN' || Data.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN'
            || Data.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN' || Data.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN' ||
            Data.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' || Data.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') &&
            Data.SelectTypicalHorizontalRIB === 'WITH STEM HOLE') {
            ciDropDown = true
            setCIShutter(true)
          } else {
            ciDropDown = false
            setCIShutter(false)
          }
          //All dropdown selection goes here
          setTimeout(() => {
            setValue([
              { 'SelectedActuatorGearBox': Data.SelectedActuatorType },
              { 'abilityOfSp1585indleStandard': Data.SelectedAbilityOfSpindle },
              { 'co_efficientOfFriction': Data.FrictionCoefficient },
              { 'MaterialOfConstruction': Data.SelectedMaterialOfConstructionWallThimble },
              { 'LengthOfBoltsWallThimble': Data.SelectedLengthOfBoltsWallThimble },
              { 'SelectedMOCWallThimble': Data.SelectedMaterialOfConstructionWallThimble },
              { 'quantityOfFasteners': Data.QuantityOfFastenersWallThimble },
              { 'DiaOfBoltsWallThimble': Data.SelectedDiameterOfBoltsWallThimble },
              { 'lengthEmbededConcrete': Data.SelectedLengthOfBoltsWallThimble },
              { 'SelectedMaterialOfSelectedBol': Data.SelectedMaterialOfBoltForYoke },
              { 'SelectedDiameterOfBolt': Data.SelectedDiameterOfBoltsForYoke },
              { 'SelectedLengthOfBolt': Data.SelectedLengthOfBoltsForYoke },
              { 'quantityOfBolt': Data.QuantityOfBoltOnPillarForYoke },
              { 'MaterialOfBoltForYoke': Data.SelectedMaterialOfBoltForYoke },
              { 'DiameterOfBoltsForYoke': Data.SelectedDiameterOfBoltsForYoke },
              { 'LengthOfBoltsForYoke': Data.SelectedLengthOfBoltsForYoke },
              { 'SlideOrSluiceGateStandard': Data.SelectedSlideOrSluiceGateStandard },
              { 'MaterialOfConstructionYoke': Data.SelectedMaterialOfConstructionYoke },
              { 'YokeSection': Data.SelectedYokeSection },
              { 'ThicknessOfSection': Data.SelectedYokeThickness },
              { 'abilityOfSpindleStandard': Data.SelectedAbilityOfSpindle },
              { 'unsupportedLengthForUnthreadedStem': Data.UnsupportedLengthForUnthreadedStemSection },
              { 'weightOfDoor': Data.DoorWeight },
              { 'factorOfSafetyElectrical': Data.SelectedFactorOfSafetyElectrical },
              { 'SelectedMaterialOfSelectedBolt': Data.SelectedMaterialOfBoltForYoke },
              { 'stemDiameterDD': ciDropDown ? Data.SelectedStemDiameter : Data.SelectedStemDiameterElectrical },
            ])
            setLoader(false)
          }, 100)
        }
      })
    } else {
      setLoader(false)
    }
  }, [])

  // const rnderRow = (
  //     firstColoum = '',
  //     secondColoum = '',
  //     thirdColoum = '',
  //     fourthColoum = ''
  // ) => {
  //     return (
  //         <Row className="mb-3">
  //             <Col md="6">
  //                 <p>{firstColoum}</p>
  //             </Col>
  //             <Col md="2">
  //                 <p>{secondColoum}</p>
  //             </Col>
  //             <Col md="2">
  //                 <p>{thirdColoum}</p>
  //             </Col>
  //             <Col md="2">
  //                 <p>{fourthColoum}</p>
  //             </Col>
  //         </Row>

  //     )
  // }

  // const renderSingleColoumRow = (data) => {
  //     return (
  //         <Row className="mb-3">
  //             <Col md="12">
  //                 <p>{data}</p>
  //             </Col>
  //         </Row>

  //     )
  // }

  // const renderHeading = (data) => {
  //     return (
  //         <Row className="mb-3">
  //             <Col md="12">
  //                 <p className={'mt15'}><b>{data}</b></p>
  //             </Col>
  //         </Row>

  //     )
  // }

  // const maxWaterHead = () => {
  //     if (intSeatingHead && intUnseatingHead) {
  //         if (intSeatingHead < intUnseatingHead) {
  //             return intUnseatingHead
  //         } else {
  //             return intSeatingHead
  //         }
  //     } else {
  //         return 0
  //     }
  // }

  // const threadPitch = () => {

  //     if (diameterOfSpindle < 36) {
  //         return 6;
  //     } else if (diameterOfSpindle < 66) {
  //         return 8;
  //     } else if (diameterOfSpindle < 76) {
  //         return 10;
  //     } else if (diameterOfSpindle < 121) {
  //         return 12;
  //     } else {
  //         return 0;
  //     }

  // }

  // const leadValue = () => {
  //     const threadPitchValue = threadPitch();
  //     const result = checkForNull(threadPitchValue * numberOfStarts);
  //     return result;
  // }

  // const finalLeadValue = () => {
  //     const lead = leadValue();
  //     return lead / 1000
  // }

  // const rootDiameter = () => {
  //     const threadPitchValue = threadPitch();
  //     const result = diameterOfSpindle - (threadPitchValue * 0.6);
  //     return result;
  // }

  // const weightOfSpindle = () => {
  //     const singleShaft = (shaftSpindle == 'SINGLE_SPINDLE') ? 1 : 2;
  //     const value = singleShaft * 3.1415 * diameterOfSpindle * diameterOfSpindle * totalLengthOfSpindle * 7.85;
  //     const spindleWeight = value / (4 * Math.pow(10, 6));
  //     return checkForNull(spindleWeight);
  // }

  // const forceRequiredToOpenTheDoor = () => {
  //     const waterHead = maxWaterHead()
  //     const spindleWeight = weightOfSpindle();
  //     const value = cofficientOfFriction * (intWidth * Math.pow(10, -3)) * (intHeight * Math.pow(10, -3)) * densityOfSewage * (waterHead)
  //     const force = value + (1.5 * weigth + spindleWeight)

  //     return force ? checkForNull(force) : 0;
  // }


  // const hoistingCapacity = () => {
  //     const force = forceRequiredToOpenTheDoor();
  //     const value = force * gravity / 1000
  //     return value;
  // }
  // const newhoistingCapacity = hoistingCapacity() * 1.25;
  // const axialLoadOnStem = forceRequiredToOpenTheDoor() / 1;
  // hoistingCapacityValue = newhoistingCapacity

  // const section2RootDiameter = () => {
  //     const value = (axialLoadOnStem * 200 * 200 * 4 * 9.81) / (2 * 3.1415 * 3.1415 * 3.1415 * 2 * 100000);
  //     return Math.sqrt(value);
  // }

  // const pitchSpindleDiameter = () => {
  //     const value = threadPitch();
  //     return (finishedDiaOfSpindle - (0.3 * value)) / 1000;
  // }

  // const stemFactor = () => {
  //     const val1 = pitchSpindleDiameter();
  //     const val2 = finalLeadValue();
  //     // const calc1 = val1 * 0.5;
  //     // const calc2 = 3.1415 * val1;
  //     // const calc3 = val2 / calc2;
  //     // const calc4 = calc3 + frictionCofficient;
  //     // const calc5 = val2 * frictionCofficient
  //     // const calc6 = 3.1415 * val1;
  //     // const calc7 = calc5 / calc6;
  //     // const calc8 = 1 - calc7;
  //     // const calc9 = calc4 / calc8;

  //     const total = val1 * 0.5 * ((val2 / (3.1415 * val1)) + frictionCofficient) / (1 - (val2 * frictionCofficient) / (3.1415 * val1))
  //     return checkForNull(total);
  // }

  // const operatingTorqueAtGearBox = () => {
  //     const val1 = newhoistingCapacity;
  //     const val2 = stemFactor();
  //     const calc1 = val1 * val2

  //     if (shaftSpindle == 'SINGLE_SPINDLE') {
  //         return checkForNull(calc1)
  //     } else {
  //         return checkForNull(calc1 / 2)
  //     }
  // }

  // const finalOperatingTorqueAtGearBox = operatingTorqueAtGearBox() * 1000;
  // const finalOperatingTorqueAtGearBoxDividedByGravity = finalOperatingTorqueAtGearBox / gravity;
  // const gearReductionRatio = () => {
  //     if (selectedGearboxModel === 'OTHER') {
  //         return 1
  //     } else {
  //         return selectedGearRatio
  //     }
  // }
  // const torqueAtOperatingShaft = () => {
  //     const val1 = finalOperatingTorqueAtGearBox;
  //     const val2 = gearReductionRatio();
  //     return checkForNull(val1 / (gearEfficiency * val2));
  // }

  // const effortAtHandWheel = () => {
  //     const val1 = torqueAtOperatingShaft();
  //     const result = checkForNull(val1 / selectedCrankRadius)
  //     return result
  // }
  // const effortAtHandWheelDividedByGravity = checkForNull(effortAtHandWheel() / gravity);
  // const gearRatio = typeOfOperation === 'Ungeared' ? 0 : gearReductionRatio

  // const actualHeight = () => {
  //     if (true) {
  //         return checkForNull(intHeight + 10);
  //     } else {
  //         return checkForNull(intHeight + 30 + 15);
  //     }
  // }

  // const turnsRequiredToOpenGate = () => {
  //     const val1 = actualHeight();
  //     const val2 = gearRatio;
  //     const val3 = leadValue();
  //     const result = checkForNull(val1 * val2 / val3);
  //     return result;
  // }

  // const timeRequiredToManuallyOpenGate = () => {
  //     const val1 = turnsRequiredToOpenGate();
  //     const result = checkForNull(val1 / 20);
  //     return result;
  // }

  // const maximumTorqueAtStemNut = () => {
  //     const val1 = maximumTorqueByOperator;
  //     const val2 = checkForNull(gearEfficiency * gearReductionRatio())
  //     const result = val1 / val2
  //     return result
  // }

  // const compressiveForceToSpindle = () => {
  //     const val1 = maximumTorqueAtStemNut();
  //     const val2 = checkForNull(stemFactor() * 1.25);
  //     const result = val1 / val2;
  //     return result;
  // }

  // const compressiveForceFactorOfSafety = checkForNull(compressiveForceToSpindle() * 2);
  // const factorOfSafetyMultipliedByGravity = compressiveForceFactorOfSafety * gravity;

  // const criticalLoad = () => {
  //     const val1 = factorOfSafetyMultipliedByGravity;
  //     const val2 = Math.pow(unsupportedLength, 2);
  //     const val3 = val1 * val2 * 64;
  //     const val4 = Math.pow(3.14, 3);
  //     const val5 = val4 * youngsModulusOfElasticity * endConditionConstant;
  //     const result = checkForNull(val3 / val5);
  //     return result;
  // }

  // const finalCriticalLoad = Math.pow(criticalLoad(), 1 / 4);
  // const slendernessRation = () => {
  //     const val1 = unsupportedLength * 4;
  //     const result = checkForNull(val1 / diameterOfSpindle);
  //     return result;
  // }

  // const slendernessRationUnthreaded = () => {
  //     const val1 = unsupportedLengthThreaded * 4;
  //     const result = checkForNull(val1 / rootDiameter());
  //     return result;
  // }

  // const threadDepth = checkForNull(threadPitch() * 0.3);
  // const effectiveDiameter = checkForNull(finishedDiaOfSpindle - threadDepth);
  // const staticallyReversibleCondition = 3.1415 * staticFrictionCoefficient * effectiveDiameter
  // const dynamicallyReversibleCondition = 3.1415 * dynamicFrictionCoefficient * effectiveDiameter
  // const forceActingOnFrame = () => {
  //     const val1 = intWidth * intHeight * densityOfSewage * maxWaterHead();
  //     const result = checkForNull(val1 / 1000000)
  //     return result
  // }

  // const finalForceActingOnFrame = () => {
  //     const val1 = forceActingOnFrame() * gravity;
  //     const result = checkForNull(val1 / 1000);
  //     return result;
  // }

  // const gearBoxSelection = () => {
  //     return selectedActuatorGearBox == 'WITH-GEAR-BOX' ? true : false;
  // }

  // const maxStemAcceptanceOKAlert = () => {
  //     let tempValue = '';
  //     if (gearBoxStemAcceptance == '') {
  //         tempValue = '';
  //     } else if (gearBoxStemAcceptance == 0) {
  //         tempValue = 0;
  //     } else {
  //         tempValue = gearBoxStemAcceptance;
  //     }
  //   }

  const factorOfSafety = [
    { label: "STANDARD", value: "STANDARD" },
    { label: "CUSTOM", value: "CUSTOM" }
  ];
  const rnderRowMinSpace = (
    firstColoum = "",
    secondColoum = "",
    thirdColoum = "",
    fourthColoum = "",
    firstColoumSize = null,
    secondColoumSize = null,
    thirdColoumSize = null,
    fourthColoumSize = null
  ) => {
    return (
      <Row className="mb-3">
        <Col
          md={firstColoumSize ? firstColoumSize : "5"}
          className="cr-mm-dimension"
        >
          <p>{firstColoum}</p>
        </Col>
        <Col md={secondColoumSize ? secondColoumSize : "2"}>
          <p className="text-right">{secondColoum} </p>
        </Col>
        <Col md={thirdColoumSize ? thirdColoumSize : "5"}>
          <p>{thirdColoum} {fourthColoum}</p>
        </Col>
        {/* <Col md={fourthColoumSize ? fourthColoumSize : "2"}>
                <p>{fourthColoum}</p>
            </Col> */}
      </Row>
    );
  };
  const rnderRow = (
    firstColoum = "",
    secondColoum = "",
    thirdColoum = "",
    fourthColoum = ""
  ) => {
    return (
      <Row>
        <Col md="5" className="mb-3">
          <p>{firstColoum}</p>
        </Col>
        <Col md="2" className="mb-3">
          <p className="text-right">{secondColoum}</p>
        </Col>
        <Col md="2" className="mb-3">
          <p>{thirdColoum}</p>
        </Col>
        <Col md="3" className="mb-3">
          <p>{fourthColoum}</p>
        </Col>
      </Row>
    );
  };
  const rnderRowFormula = (
    firstColoum = "",
    secondColoum = "",
    thirdColoum = ""
  ) => {
    return (
      <Row className="mb-3">
        <Col md="5">
          <p>{firstColoum}</p>
        </Col>
        <Col md="2">
          <p className="text-right">{secondColoum}</p>
        </Col>
        <Col md="5">
          <p>{thirdColoum}</p>
        </Col>
      </Row>
    );
  };

  const renderSingleColoumRow = (data) => {
    return (
      <Row className="mb-3">
        <Col md="12">
          <p>{data}</p>
        </Col>
      </Row>
    );
  };

  const renderHeading = (data) => {
    return (
      <Row className="mb-2 mt-4">
        <Col md="12">
          <p className={"page-heads"}>
            <b>{data}</b>
          </p>
        </Col>
      </Row>
    );
  };
  const renderHeadingType2 = (data) => {
    return (
      <Col md="7">
        <p className={"page-heads"}>
          <b>{data}</b>
        </p>
      </Col>
    );
  };

  const maxWaterHead = () => {
    if (Number(checkForNull(intSeatingHead)) < Number(checkForNull(intUnseatingHead))) {
      return intUnseatingHead;
    } else {
      return intSeatingHead;
    }

  };

  const threadPitch = () => {
    if (stemDiameterDD < 36) {
      return 6;
    } else if (diameterOfSpindle < 66) {
      return 8;
    } else if (diameterOfSpindle < 76) {
      return 10;
    } else if (diameterOfSpindle < 121) {
      return 12;
    } else {
      return 12;
    }
  };

  const leadValue = () => {
    const threadPitchValue = threadPitch();
    const result = checkForNull(threadPitchValue * numberOfStarts);
    return result;
  };

  const finalLeadValue = () => {
    const lead = leadValue();
    return lead / 1000;
  };

  const rootDiameter = () => {
    const threadPitchValue = threadPitch();
    const result = diameterOfSpindle - threadPitchValue * 0.6;
    return result;
  };


  const totalLengthOfSpindleCalc = () => {
    let FL = frameLengthValue
    let frameExtension = frameExtensionValue
    //1
    let tempVal, ref1, ref2, tempObj
    SeriesOfferedOption &&
      SeriesOfferedOption.map((item) => {
        if (String(SelectedSeriesOffered) === String(item.Value)) {
          tempObj = item.Key
        }

        // tempObj = {
        //     label: checkForNull(parseFloat(item.Text)).toFixed(2),
        //     value: item.Value,
        // };
        // tempArr.push(tempObj);
      });

    if (tempObj === '3') {
      tempVal = (Number(cl_pl) * 1000 + (0.5 * Number(height)) + 1300)
    } else {
      tempVal = (cl_pl * 1000 - (0.5 * height) + 1300)
    }

    if (tempObj === '2') {
      ref1 = 0
      ref2 = 1
    } else {
      ref1 = 1
      ref2 = 0
    }
    let tempVal2

    // =IF(selectedSeriesOffered=A-311 & 321,
    //     (5*1000+(0.5*914)+1300)*0+(914 +250+500+100)*1

    //     (5*1000-(0.5*914 )+1300)) 

    // =IF(D10=D251,(H8*1000+(0.5*I4)+1300),(H8*1000-(0.5*I4)+1300))*E10+(I4+250+500+100)*E9*0+(914 +250+500+100)*1

    tempVal2 = Number(tempVal) * Number(ref1) + (Number(height) + 250 + 500 + 100) * Number(ref2)
    //__________________

    //2
    // =(I4+250+500)*E10+((H9*1000)-I4+150+100+250+500)*E9
    let ref3
    let ref4
    if (tempObj === '2') {
      ref3 = 0
      ref4 = 1
    }
    else {
      ref3 = 1
      ref4 = 0
    }
    let tempVal3 = (Number(height) + 250 + 500) * Number(ref3) + ((Number(FL) * 1000) - Number(height) + 150 + 100 + 250 + 500) * Number(ref4)

    //______________________
    //3

    // = IF(AND(D15 = D501), 
    // (I4 * IF(D10 = D251, 1.66, 1.5) + 100), 
    // IF(AND(D15 = D502, D16 = B524), (I4 * 2 + IF(D10 = D251, 250, 100)), H9 * 1000))


    let ref5, ref6
    if (SelectedFrameLengthType === 'SHORT LENGTH') {
      ref5 = tempObj === '3' ? 1.66 : 1.5
      ref6 = (Number(height) * Number(ref5) + 100)
    }
    else {
      if (SelectedFrameLengthType === 'FULL LENGTH' && frameExtension === 'SELF CONTAINED FRAME WITH EXT LENGTH') {

        ref5 = tempObj === '3' ? 250 : 100

        ref6 = (Number(height) * 2 + Number(ref5))
      }
      else {
        ref6 = Number(FL) * 1000
      }
    }
    let refVal1

    refVal1 = tempObj === '3' ? 0.6 : 1

    let ref7
    let ref8
    let value3
    if (tempObj === '2') {
      ref7 = 0
      ref8 = 1
    }
    else {
      ref7 = 1
      ref8 = 0
    }
    // =(E23+250+500-(I4*IF(D10=D251,0.6,1)))*E10+(H8*1000-(I4/2)+(900+350))*E9
    value3 = (Number(ref6) + 250 + 500 - (Number(height) * Number(refVal1))) * Number(ref7) + (Number(cl_pl) * 1000 - (Number(height) / 2) + (900 + 350)) * Number(ref8)
    let finalCalc

    // = IF(AND(D15 = D502, F508 = D20, D16 = B524), K7, IF(AND(D15 = D502, F508 = D20, D16 = B525), K8, K6))

    // = IF(AND(D15 = D502, F508 = D20, D16 = B524), K7, IF(AND(D15 = D502, F508 = D20, D16 = B525), K8, K6))

    //3 value3  tempVal3   tempVal2 1
    if (tempObj === '1' || tempObj === '3') {
      if (SelectedFrameLengthType === 'FULL LENGTH' && selectedThrustOn === 'FRAME' &&
        frameExtension === 'NOT REQUIRED') {
        finalCalc = tempVal3
      }
      else if (SelectedFrameLengthType === 'FULL LENGTH' && selectedThrustOn === 'FRAME'
        && frameExtension === 'REQUIRED') {
        finalCalc = value3
      }
      else {
        finalCalc = tempVal2
      }
    } else {
      if (SelectedFrameLengthType === 'FULL LENGTH' && selectedThrustOn === 'FRAME' &&
        frameExtension === 'SELF CONTAINED FRAME WITH EXT LENGTH') {
        finalCalc = tempVal3
      }
      else if (SelectedFrameLengthType === 'FULL LENGTH' && selectedThrustOn === 'FRAME'
        && frameExtension === 'CLOSED TOP FRAME WITH EXT STEM LENGTH') {
        finalCalc = value3
      }
      else {
        finalCalc = tempVal2
      }
    }
    return finalCalc
  }

  const weightOfSpindle = () => {
    const singleShaft = shaftSpindle === "SINGLE SPINDLE" ? 1 : 2;
    const value =
      Number(singleShaft) *
      3.1415 *
      Number(diameterOfSpindle) *
      Number(diameterOfSpindle) *
      Number(totalLengthOfSpindleCalc()) *
      7.85;
    const spindleWeight = Number(value) / (4 * Math.pow(10, 6));

    // =AF26*3.1415*AF22*AF22*AF25*7.95/(4*10^6)

    return checkForNull(spindleWeight);
  };

  const forceRequiredToOpenTheDoor = () => {
    const waterHead = maxWaterHead();
    const spindleWeight = weightOfSpindle();
    const value =
      cofficientOfFriction *
      (intWidth * Math.pow(10, -3)) *
      (intHeight * Math.pow(10, -3)) *
      densityOfSewage *
      waterHead;
    const force = value + (1.5 * weigth + spindleWeight);

    // .2*(914*10^-3)*(914*10^-3)*1010*(1.543)+(1.5*51.2162532 +127)

    // 0.2 *(914*10^-3)*(914*10^-3)*1010*(1.54)+(1.5*51.2162532 +127)

    // 126.992510420625


    // 463.69187790062506 




    return force ? checkForNull(force) : 0;
  };

  const hoistingCapacity = () => {
    const force = forceRequiredToOpenTheDoor();
    const value = (force * gravity) / 1000;
    return value;
  };
  const newhoistingCapacity = hoistingCapacity() * hoistingCapacityPercent.value;
  const axialLoadOnStem = forceRequiredToOpenTheDoor() / 1;
  hoistingCapacityValue = newhoistingCapacity;

  const section2RootDiameter = () => {
    // =SQRT((348.15      *200*200*4*9.81)/(2*3.1415*3.1415*3.1415*2*100000))

    // axialLoadOnEachStemCalculation()
    const value =
      (axialLoadOnEachStemCalculation() * 200 * 200 * 4 * 9.81) /
      (2 * 3.1415 * 3.1415 * 3.1415 * 2 * 100000);
    return Math.sqrt(value);
  };

  const pitchSpindleDiameter = () => {
    const value = threadPitch();
    return (finishedDiaOfSpindle - 0.3 * value) / 1000;
  };

  const stemFactor = () => {
    const val1 = pitchSpindleDiameter();
    const val2 = finalLeadValue();
    // const calc1 = val1 * 0.5;
    // const calc2 = 3.1415 * val1;
    // const calc3 = val2 / calc2;
    // const calc4 = calc3 + frictionCofficient;
    // const calc5 = val2 * frictionCofficient
    // const calc6 = 3.1415 * val1;
    // const calc7 = calc5 / calc6;
    // const calc8 = 1 - calc7;
    // const calc9 = calc4 / calc8;

    const total =
      (val1 * 0.5 * (val2 / (3.1415 * val1) + frictionCofficient)) /
      (1 - (val2 * frictionCofficient) / (3.1415 * val1));
    return checkForNull(total);
  };

  const operatingTorqueAtGearBox = () => {
    const val1 = newhoistingCapacity;
    const val2 = stemFactor();
    const calc1 = val1 * val2;

    if (shaftSpindle === "SINGLE SPINDLE") {
      return checkForNull(calc1);
    } else {
      return checkForNull(calc1 / 2);
    }
  };

  const finalOperatingTorqueAtGearBox = operatingTorqueAtGearBox() * 1000;
  const finalOperatingTorqueAtGearBoxDividedByGravity =
    finalOperatingTorqueAtGearBox / gravity;
  const gearReductionRatio = () => {
    if (selectedGearboxModel === "OTHER") {
      return 1;
    } else {
      return selectedGearRatio;
    }
  };
  const torqueAtOperatingShaft = () => {
    const val1 = finalOperatingTorqueAtGearBox;
    const val2 = gearReductionRatio();
    return checkForNull(val1 / (gearEfficiency * val2));
  };

  const effortAtHandWheel = () => {
    const val1 = torqueAtOperatingShaft();
    const result = checkForNull(val1 / selectedCrankRadius);
    return result;
  };
  const effortAtHandWheelDividedByGravity = checkForNull(
    effortAtHandWheel() / gravity
  );
  const gearRatio = typeOfOperation === "Ungeared" ? 0 : gearReductionRatio;

  const actualHeight = () => {
    if (true) {
      return checkForNull(intHeight + 10);
    } else {
      return checkForNull(intHeight + 30 + 15);
    }
  };

  const turnsRequiredToOpenGate = () => {
    const val1 = actualHeight();
    const val2 = gearRatio;
    const val3 = leadValue();
    const result = checkForNull((val1 * val2) / val3);
    return result;
  };

  const timeRequiredToManuallyOpenGate = () => {
    const val1 = turnsRequiredToOpenGate();
    const result = checkForNull(val1 / 20);
    return result;
  };

  const maximumTorqueAtStemNut = () => {
    const val1 = maximumTorqueByOperator;
    const val2 = checkForNull(gearEfficiency * gearReductionRatio());
    const result = val1 / val2;
    return result;
  };

  const compressiveForceToSpindle = () => {
    const val1 = maximumTorqueAtStemNut();
    const val2 = checkForNull(stemFactor() * 1.25);
    const result = val1 / val2;
    return result;
  };

  const compressiveForceFactorOfSafety = checkForNull(
    compressiveForceToSpindle() * 2
  );
  const factorOfSafetyMultipliedByGravity =
    compressiveForceFactorOfSafety * gravity;

  const criticalLoad = () => {
    const val1 = factorOfSafetyMultipliedByGravity;
    const val2 = Math.pow(unsupportedLength, 2);
    const val3 = val1 * val2 * 64;
    const val4 = Math.pow(3.14, 3);
    const val5 = val4 * youngsModulusOfElasticity * endConditionConstant;
    const result = checkForNull(val3 / val5);
    return result;
  };

  const finalCriticalLoad = Math.pow(criticalLoad(), 1 / 4);
  const slendernessRation = () => {
    const val1 = unsupportedLength * 4;
    const result = checkForNull(val1 / diameterOfSpindle);
    return result;
  };

  const slendernessRationUnthreaded = () => {
    const val1 = unsupportedLengthThreaded * 4;
    const result = checkForNull(val1 / rootDiameter());
    return result;
  };

  const threadDepth = checkForNull(threadPitch() * 0.3);
  const effectiveDiameter = checkForNull(finishedDiaOfSpindle - threadDepth);
  const staticallyReversibleCondition =
    3.1415 * staticFrictionCoefficient * effectiveDiameter;
  const dynamicallyReversibleCondition =
    3.1415 * dynamicFrictionCoefficient * effectiveDiameter;

  const forceActingOnFrame = () => {
    const val1 = intWidth * intHeight * densityOfSewage * intUnseatingHead;





    const result = checkForNull(val1 / 1000000);

    return result;
  };

  const finalForceActingOnFrame = () => {
    const val1 = forceActingOnFrame() * gravity;
    const result = checkForNull(val1 / 1000);
    return result;
  };

  const gearBoxSelection = () => {
    return selectedActuatorGearBox === "WITH-GEAR-BOX" ? true : false;
  };

  const maxStemAcceptanceOKAlert = () => {
    let tempValue = "";
    if (gearBoxStemAcceptance === "") {
      tempValue = "";
    } else if (Number(gearBoxStemAcceptance) === 0) {
      tempValue = 0;
    } else {
      tempValue = gearBoxStemAcceptance;
    }
    if (gearBoxStemMaxAcceptance > tempValue && gearBoxSelection()) {
      return "OK";
    } else if (String(gearBoxStemMaxAcceptance) === String(tempValue) && gearBoxSelection()) {
      return "OK";
    } else {
      return "";
    }
  };

  const maxThrustCapacityOKAlert = () => {
    if (gearBoxMaxThrustCapacity > newhoistingCapacity && gearBoxSelection()) {
      return "OK";
    } else {
      return "";
    }
  };

  const maxTorqueCapacityOKAlert = () => {
    if (
      gearBoxMaxTorqueCapacity > finalOperatingTorqueAtGearBox &&
      gearBoxSelection()
    ) {
      return "OK";
    } else {
      return "";
    }
  };

  const inputShaftTorqueSpindle = () => {
    if (shaftSpindle === "SINGLE SPINDLE") {
      return "Input shaft torque at Gear box on spindle (in N-m)";
    } else {
      return "Input shaft torque at Gear box on each spindle (in N-m)";
    }
  };

  const operatingTorqueDriveNut = () => {
    if (shaftSpindle === "SINGLE SPINDLE") {
      return "Operating torque at drive nut of spindle / M.A. of Gear box";
    } else {
      return "Operating torque at drive nut of each spindle / M.A. of GB";
    }
  };

  const inputShaftTorqueBlankReturn = () => {
    if (shaftSpindle === "SINGLE SPINDLE") {
      return '';
    } else {
      return checkForNull(
        (finalOperatingTorqueAtGearBox / gearBoxMechanicalAdvantage) * 2
      );
    }
  };

  const torqueRequiredAcuator = () => {
    if (shaftSpindle === "SINGLE SPINDLE") {
      return checkForNull(
        finalOperatingTorqueAtGearBox / gearBoxMechanicalAdvantage
      );
    } else {
      return checkForNull(inputShaftTorqueBlankReturn());
    }
  };

  const thrustRequiredAcuator = () => {
    return checkForNull(newhoistingCapacity / gearBoxMechanicalAdvantage);
  };

  const clouserActualHeight = () => {
    if (ClosureType === "FLUSH BOTTOM CLOSURE") {
      return "Actual height to be opened in case of FBC ( H+10)";
    } else {
      return "Actual height to be opened in case of CBC ( H+30+15)";
    }
  };

  const clouserActualHeightCalculation = () => {
    if (ClosureType === "FLUSH BOTTOM CLOSURE") {
      return checkForNull(intHeight + 10);
    } else if (ClosureType === "CONVENTIONAL BOTTOM CLOSURE") {
      return checkForNull(intHeight + 30 + 15);
    } else {
      return 0;
    }
  };

  const numberOfTurnsOpenGate = () => {
    return checkForNull(clouserActualHeightCalculation() / leadValue());
  };

  const minimumActuatorRevolutions = () => {
    const numberOfTurns = numberOfTurnsOpenGate() * gearBoxRatio;

    return checkForNull(parseInt(numberOfTurns / availTimeOpenGate));
  };

  const actuatorModelOK = () => {
    if (minimumActuatorRevolutions() - 0.5 < actuatorModelRPM) {
      return "OK";
    } else {
      return "Reselect";
    }
  };

  const actuatorTorqueOK = () => {
    if (torqueRequiredAcuator() < actuatorTorqueRPM) {
      return "OK";
    } else {
      return "Reselect";
    }
  };

  const maximumThrustCapacityAcuatorOK = () => {
    if (thrustRequiredAcuator() < maximumThrustCapacityAcuator) {
      return "OK";
    } else {
      return "Reselect";
    }
  };

  const spindleAcceptanceActuatorModelOK = () => {
    if (
      gearBoxSelection() &&
      gearBoxOutputDiameter - 0.5 < spindleAcceptanceActuatorModel
    ) {
      return "OK";
    } else if (
      !gearBoxSelection() &&
      diameterOfSpindle - 0.5 < spindleAcceptanceActuatorModel
    ) {
      return "OK";
    } else {
      return "Reselect";
    }
  };

  const torqueAtGearBoxOutput = () => {
    if (gearBoxSelection()) {
      return "Torque at Gear box output shaft of spindle";
    } else {
      return "Torque on the drive nut of either Gear box for tandem spindle";
    }
  };

  const VerificationGearBox = () => {
    if (gearBoxSelection()) {
      return "Mechanical advantage of Gear box";
    } else {
      return "Torque at input shaft of each Gear box";
    }
  };

  const VerificationGearBoxDisplay = () => {
    if (selectedSpindle()) {
      return checkForNull(gearBoxMechanicalAdvantage);
    } else {
      return "To / Mechanical advantage of Gear box";
    }
  };

  const torqueDriveNutActuator = () => {
    if (selectedSpindle()) {
      return "Torque at input shaft of Gear box";
    } else {
      return "Torque at input shaft of (Gear box 1 + Gear box 2)";
    }
  };

  const torqueDriveNutActuatorCalculation = () => {
    const torqueDriveNut = checkForNull(
      finalOperatingTorqueAtGearBox / gearBoxMechanicalAdvantage
    );
    if (selectedSpindle()) {
      return torqueDriveNut;
    } else {
      return torqueDriveNut + torqueDriveNut;
    }
  };

  const bevelGearMechanicalAdvantage = () => {



    return checkForNull(gearRatioBetweenBevelActuator * mechanicalEfficiencyBevel);
  };

  const requiredEffortActuatorHandwheel = () => {
    const total =
      (torqueDriveNutActuatorCalculation() /
        (actuatorHandwheelRadius * bevelGearMechanicalAdvantage())) *
      1000;
    return checkForNull(total);
  };

  const verificationSuitabilityAlert = () => {
    const requiredEffortActuator = requiredEffortActuatorHandwheel() / 9.81;
    if (requiredEffortActuator < 27) {
      return "As effort required is less than 27 Kgs, the selected combination of Gear box (if any) & Actuator model is OK.";
    } else {
      return <p className='error'>Design is Un-safe, Please re-design.</p>;
    }
  };

  const stallThrustLoad = () => {
    const load =
      (thrustRequiredAcuator() * stallTorque) / torqueRequiredAcuator();
    return checkForNull(load);
  };

  const ratedThrustLoad = () => {
    const load =
      (thrustRequiredAcuator() * actuatorTorqueRPM) / torqueRequiredAcuator();
    return checkForNull(load);
  };

  const thrustLoadAlertMessage = () => {
    if (
      maximumThrustCapacityAcuator > ratedThrustLoad() &&
      maximumThrustCapacityAcuator > stallThrustLoad()
    ) {
      return "The rated thrust (Pr) as well as stall thrust (Ps) is within Maximum thrust taking capacity of selected actuator. Hence selection is OK.";
    } else {
      return <p className='error'>Design is Un-safe, Please re-design.</p>;
    }
  };

  const doorSpeed = () => {
    const result = (acutatorSpeed * leadValue()) / gearBoxRatio;
    return checkForNull(result);
  };

  const outputThrust = () => {
    if (standard === "As Per AWWA Standard") {
      return stallThrustLoad();
    } else if (standard === "As Per BS7775 Standard") {
      return ratedThrustLoad();
    } else {
      return stallThrustLoad();
    }
  };

  const criticalBulkingForce = () => {
    let value = 0;
    if (standard === "As Per AWWA C560 standard") {
      value = checkForNull(1.25 * stallThrustLoad() * gearBoxMechanicalAdvantage);
    } else if (standard === "As Per AWWA C561/C562 standard") {
      value = checkForNull(1.5 * stallThrustLoad() * gearBoxMechanicalAdvantage);
    } else if (standard === "As Per BS7775 standard") {
      value = checkForNull(stallThrustLoad() * gearBoxMechanicalAdvantage);
    } else {
      value = checkForNull(1.25 * stallThrustLoad() * gearBoxMechanicalAdvantage);
    }
    criticalBulkingForceValue = value;
    return value;
  };

  const MaxCriticalCalc = () => {
    // =IF(E18=2,BB192,"")
    // =IF(E18=2,0.75,1)
    let val = shaftSpindle === "TANDEM SPINDLE" ? 0.75 : 1
    return shaftSpindle === "TANDEM SPINDLE" ? finalCriticalBulkingForce * val : ""
  };

  const finalCriticalBulkingForce = criticalBulkingForce() * 1000;
  const calculateDr4 = () => {
    const BB40 = shaftSpindle !== "SINGLE SPINDLE" ? 0.75 : 1;
    const BB193 =
      shaftSpindle !== "SINGLE SPINDLE"
        ? finalCriticalBulkingForce * BB40
        : finalCriticalBulkingForce;

    const result =
      (BB193 * Math.pow(lengthOfColoum, 2) * 64) /
      (Math.pow(3.14, 3) * youngsModulusOfElasticity * endConditionConstant);

    return checkForNull(result);
  };

  const finalCalculateDr4 = checkForNull(Math.pow(calculateDr4(), 1 / 4));

  const spindleBucklingAlertMessage = () => {
    if (finalCalculateDr4 < rootDiameter()) {
      return "Since selected spindle diameter is more than the spindle diameter required to withstand Buckling, the design is safe.";
    } else {
      return <p className='error'>Design is Un-safe, Please re-design.</p>;
    }
  };

  //const permissibleShearStress = materialOfSelectedBolt === 'Stainless Steel' ? 7.03 : 6.12;

  const permissibleShearStress = () => {
    if (materialOfConstruction === "Cast Iron") {
      return 5.87;
    } else if (materialOfConstruction === "Stainless Steel") {
      return 7.03;
    } else {
      return 6.12;
    }
  };

  const permissibleShearStressFS = () => {
    if (materialOfSelectedBolt === "Stainless Steel") {
      return 7.03;
    } else {
      return 6.12;
    }
  };

  const loadOnEachFastner = checkForNull(
    ratedThrustLoad().toFixed(2) / quantityOfBoltOnPillar
  );
  const threadPitchOfSelectedAnchorNut = () => {
    if (diameterOfBolt < 17) {
      return 2;
    } else if (diameterOfBolt < 21) {
      return 2.5;
    } else if (diameterOfBolt < 28) {
      return 3;
    } else {
      return 3.5;
    }
  };

  const threadPitchOfSelectedAnchorNutTappedHole = () => {
    if (diaOfBolts < 17) {
      return 2;
    } else if (diaOfBolts < 21) {
      return 2.5;
    } else if (diaOfBolts < 28) {
      return 3;
    } else {
      return 3.5;
    }
  };

  const permissibleShearStrengthOfNut = () => {
    const result =
      (3.1415 *
        (diameterOfBolt - threadPitchOfSelectedAnchorNut() / 2) *
        (diameterOfBolt * 0.8) *
        permissibleShearStressFS() *
        9.81) /
      1000;
    return checkForNull(result);
  };

  const permissiableShearStrengthOfTappedHole = () => {
    const result =
      (3.1415 *
        (diaOfBolts - threadPitchOfSelectedAnchorNutTappedHole() / 2) *
        (diaOfBolts * 0.8) *
        permissibleShearStress() *
        9.81) /
      1000;
    return checkForNull(result);
  };

  const handleChange = (value) => {
    setSlideSluiceGateStandard(value);
    switch (value) {
      case "BS7775 : 1995 standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(1.25);
        setonOffSeatingHeadLessThan6Value(2.51);
        setOnseatingHeadMoreThan6Value(0);
        setOnOffseatingHeadMoreThan6Value(0);
        break;

      case "BS7775 : 2005 standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(0.5);
        setonOffSeatingHeadLessThan6Value(0.5);
        setOnseatingHeadMoreThan6Value("0.1 + 0.067 H(U)");
        setOnOffseatingHeadMoreThan6Value("0.1 + 0.067 H(U)");
        break;

      case "AWWA C561 : standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(1.24);
        setonOffSeatingHeadLessThan6Value(1.24);
        setOnseatingHeadMoreThan6Value(1.24);
        setOnOffseatingHeadMoreThan6Value(1.24);
        break;

      case "AWWA C513 : standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(1.24);
        setonOffSeatingHeadLessThan6Value(1.24);
        setOnseatingHeadMoreThan6Value(1.24);
        setOnOffseatingHeadMoreThan6Value(1.24);
        break;

      case "AWWA C560 : standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(1.24);
        setonOffSeatingHeadLessThan6Value(2.48);
        setOnseatingHeadMoreThan6Value(1.24);
        setOnOffseatingHeadMoreThan6Value("1.242 + 0.204 (Head in m)");
        break;

      case "IS 13349 : 1995 standard for Sluice/Slide Gates":
        setOnseatingHeadLessThan6Value(1.25);
        setonOffSeatingHeadLessThan6Value(1.25);
        setOnseatingHeadMoreThan6Value(2.5);
        setOnOffseatingHeadMoreThan6Value(2.5);
        break;

      case "As per tender specification/other/ as agreed":
        setOnseatingHeadLessThan6Value("As Per Tender");
        setonOffSeatingHeadLessThan6Value("As Per Tender");
        setOnseatingHeadMoreThan6Value("As Per Tender");
        setOnOffseatingHeadMoreThan6Value("As Per Tender");
        break;

      default:
        setOnseatingHeadLessThan6Value(0);
        setonOffSeatingHeadLessThan6Value(0);
        setOnseatingHeadMoreThan6Value(0);
        setOnOffseatingHeadMoreThan6Value(0);
        return;
    }
  };

  const selectedSpindle = () => {
    return shaftSpindle === "SINGLE SPINDLE" ? true : false;
  };

  const shaftDisplayMessage = () => {
    if (selectedSpindle()) {
      return "Single shaft required therefore";
    } else {
      return "Tendon shaft required therefore";
    }
  };

  const axialLoadOnEachStem = () => {
    if (selectedSpindle()) {
      return `${forceRequiredToOpenTheDoor().toFixed(0)} / 1`;
    } else {
      return `${forceRequiredToOpenTheDoor().toFixed(0)} x 75%`;
    }
  };

  const axialLoadOnEachStemCalculation = () => {
    if (selectedSpindle()) {
      return (forceRequiredToOpenTheDoor() / 1).toFixed(0);
    } else {
      return ((forceRequiredToOpenTheDoor() * 75) / 100).toFixed(0);
    }
  };

  const spindleDiameterAlertMessage = () => {
    if (section2RootDiameter() < rootDiameter()) {
      return "Since selected spindle diameter is more than required spindle diameter, hence the design is safe.";
    } else {
      return <p className='error'>Design is Un-safe, Please re-design.</p>;
    }
  };

  const gateSize = checkForNull(heightInMeter * widthInMeter);
  const sealingPerimeter = checkForNull(2 * widthInMeter + 2 * heightInMeter);
  const permissibleLeakageSeatingHead = checkForNull(
    intSeatingHead < 6.00001
      ? onSeatingLessThan6Leakae
      : onSeatingMoreThan6Leakae
  );
  const permissibleLeakageUnSeatingHead = checkForNull(
    intUnseatingHead < 6.00001
      ? onOffSeatingLessThan6Leakae
      : onOffSeatingMoreThan6Leakae
  );
  const permissibleLeakageSeatingHeadIntoGallon = checkForNull(
    (permissibleLeakageSeatingHead * 0.2641721) / 3.28084
  );
  const permissibleLeakageUnSeatingHeadIntoGallon = checkForNull(
    (permissibleLeakageUnSeatingHead * 0.2641721) / 3.28084
  );
  const finalSeatingHeadPermissibleLeakage = checkForNull(
    permissibleLeakageSeatingHead * sealingPerimeter
  );
  const finalUnSeatingHeadPermissibleLeakage = checkForNull(
    permissibleLeakageUnSeatingHead * sealingPerimeter
  );
  const finalSeatingHeadPermissibleLeakageIntoGallon = checkForNull(
    permissibleLeakageSeatingHeadIntoGallon * sealingPerimeter * 3.28084
  );
  const finalUnSeatingHeadPermissibleLeakageIntoGallon = checkForNull(
    permissibleLeakageUnSeatingHeadIntoGallon * sealingPerimeter * 3.28084
  );

  const section11VaueOfH = () => {
    if (youkeSection === "A") {
      return 190;
    } else if (youkeSection === "B") {
      return 250;
    } else {
      return 250;
    }
  };
  const section11VaueOfP = () => {
    if (youkeSection === "A") {
      return 100;
    } else if (youkeSection === "B") {
      return 150;
    } else {
      return 175;
    }
  };
  const section11VaueOfQ = () => {
    if (youkeSection === "A") {
      return 60;
    } else if (youkeSection === "B") {
      return 80;
    } else {
      return 80;
    }
  };

  const calculateValueOfW = () => {
    if (forceRequiredToOpenTheDoor() < compressiveForceFactorOfSafety) {
      return checkForNull(9.81 * compressiveForceFactorOfSafety);
    } else {
      return checkForNull(9.81 * forceRequiredToOpenTheDoor());
    }
  };

  const lengthOfSpan = intWidth + 150;

  const modulusOfElasticityOfSelectedMaterial = () => {
    if (constructionMaterialOfYoke === "Stainless Steel") {
      return 199950;
    } else if (constructionMaterialOfYoke === "Carbon Steel") {
      return 199950;
    } else if (constructionMaterialOfYoke === "Aluminum Steel") {
      return 68950;
    } else {
      return 0;
    }
  }

  const slendernessRationUnthreadedSection5 = checkForNull(
    (unsupportedLengthForUnthreadedStem * 4) / diameterOfSpindle
  );
  const slendernessRationThreadedSection5 = checkForNull(
    (lengthOfColoum * 4) / checkForNull(rootDiameter())
  );
  const D4ValueCaculation = () => {
    const E18 = selectedSpindle() ? 1 : 2;
    const BB40 = E18 === 2 ? 0.75 : 1;
    const BB192 = finalCriticalBulkingForce * BB40;
    return checkForNull(
      (BB192 * Math.pow(unsupportedLengthForUnthreadedStem, 2) * 64) /
      (Math.pow(3.14, 3) * youngsModulusOfElasticity * endConditionConstant)
    );
  };

  // const finalD4ValueCaculation = Math.pow(D4ValueCaculation(), 1 / 4);

  // const tensileAreaOfStem = 3.1415 * Math.pow(rootDiameter(), 2) / 4;

  // const tensileStressInStem = finalCriticalBulkingForce / tensileAreaOfStem
  // const yieldStrengthOfMaterial = () => {
  //     if (stemMaterial) {
  //         const index = stemMaterial.indexOf('_');

  //         const val3 = stemMaterial.substr(0, index);

  //         return parseInt(val3);
  //     } else {
  //         return 0
  //     }
  // }

  const H13ValueCalculation = () => {
    const J5 =
      parseInt(width) > 1800
        ? (parseInt(width) *
          (Math.max(parseInt(seatingHead), parseInt(unseatingHead)) +
            (0.5 * parseInt(height)) / 1000)) /
        1000
        : (parseInt(width) *
          Math.max(parseInt(seatingHead), parseInt(unseatingHead))) /
        1000;
    const J4 =
      J5 < 10 ? "1A" : J5 < 15 ? "2A" : J5 < 19 ? "2B" : J5 < 25 ? "3A" : "3B";
    const E222 =
      J4 === "1A"
        ? 6.4
        : J4 === "2A"
          ? 8
          : J4 === "2B"
            ? 10
            : J4 === "3A"
              ? 10
              : 12;
    const E911 =
      parseInt(width) > parseInt(height)
        ? parseInt(width)
        : parseInt(width) < parseInt(height)
          ? parseInt(height)
          : parseInt(width) === parseInt(height)
            ? parseInt(height)
            : 0;
    const D212 =
      E911 < 2701 && parseInt(unseatingHead) > 6.2
        ? thicknessOfSkinPlate * 1.5
        : E911 > 2701 && parseInt(unseatingHead) > 10.1
          ? thicknessOfSkinPlate * 1.5 * 1.1
          : 0;
    const D210 =
      E911 < 2701 && parseInt(unseatingHead) < 6.2
        ? thicknessOfSkinPlate
        : E911 < 2701 && parseInt(unseatingHead) < 10.1
          ? thicknessOfSkinPlate * 1.5
          : 0;
    const D209 =
      E911 < 2701 && parseInt(unseatingHead) < 10.1 ? thicknessOfSkinPlate : 0;
    const E212 = E911 > 10 ? D212 : 0;
    const E211 =
      E911 > 2701 && parseInt(unseatingHead) < 6.2
        ? thicknessOfSkinPlate * 1.5
        : E911 > 2701 && parseInt(unseatingHead) < 10.1
          ? thicknessOfSkinPlate * 1.5 * 1.1
          : 0;
    const E210 = E911 < 1221 ? D209 : D210;
    const E213 = E210 + E211 + E212;

    return checkForNull(SelectedSeriesOffered === "A-113" ? E213 : E222);
  };
  const bondingStrength = 1.5;

  const lengthOfFoundationBolt = () => {
    return (
      parseInt(embededLengthConcrete) + 5 + (SelectedSeriesOffered === "A-113" ? 8 : H13ValueCalculation()) + 2 * parseInt(diaOfBolts)
    );
  };
  const workingForceOFresistance =
    (3.1215 * diaOfBolts * embededLengthConcrete * bondingStrength) / 1000;



  const totalNoOfAnchorBoltRequired = parseInt((finalForceActingOnFrame() / workingForceOFresistance)) * 1.25;

  const finalD4ValueCaculation = Math.pow(D4ValueCaculation(), 1 / 4);
  const tensileAreaOfStem = (3.1415 * Math.pow(rootDiameter(), 2)) / 4;
  const tensileStressInStem = finalCriticalBulkingForce / tensileAreaOfStem;
  const yieldStrengthOfMaterial = () => {
    // =IF(OR(AT185=AQ518,AT185=AQ519),IF(AY237="CUSTOM",G527/AY238,G527/5),IF(AY237="CUSTOM",H527/AY238,H527))
    let Data = StemMaterialData;

    let uts = 0;
    let yp = 0;
    Data && Data.map((item) => {
      if (item.Material === stemMaterial) {
        uts = item.UTS
        yp = item.Yp
      }
    })

    let tempValue
    if (standard === 'As Per AWWA C560 standard' || standard === 'As Per AWWA C561/C562 standard') {
      if (factorOfSafetyElectrical === "CUSTOM") {
        tempValue = Number(factorOfSafetyCustomValue) !== 0 ? uts / factorOfSafetyCustomValue : 0
      }
      else {
        tempValue = uts / 5
      }
      return tempValue

    }
    else {
      if (factorOfSafetyElectrical === "CUSTOM") {
        tempValue = Number(factorOfSafetyCustomValue) !== 0 ? yp / factorOfSafetyCustomValue : 0
      }
      else {
        tempValue = yp
      }
      return tempValue
    }



    // if (stemMaterial) {
    //   const index = stemMaterial.indexOf("_");

    //   const val3 = stemMaterial.substr(0, index);

    //   return parseInt(val3);
    // } else {
    //   return 0;
    // }
  };

  const foundationBoltLength = checkForNull(parseInt(lengthOfBolt) + 15 + 25 + 2 * parseInt(diameterOfBolt));
  const safeWorkingForceOFresistance = () => (3.1215 * 800 * 1.4142 * Math.pow((lengthOfBolt / 25.4), 2)) / 4448.222;
  const thrustLoadOnEachFastner = ratedThrustLoad() / parseInt(quantityOfBoltOnPillar);
  const loadOnEachFastnerNut = thrustLoadOnEachFastner;
  const maxDeflectionAtCenter = shaftSpindle === 'SINGLE_SPINDLE' ? 0.1906 : -0.6893;
  const allowableDeflectionOfYoke = checkForNull(lengthOfSpan / valueOfLSection11);
  const loadOnEachAnchorFastner = checkForNull(finalForceActingOnFrame() / quantityOfFastenrs);
  const requiredEffortActuator = requiredEffortActuatorHandwheel() / 9.81;

  /**
  * Submit the login form
  * @param values
  */
  const onSubmit = (values) => {
    if (
      requiredEffortActuator < 27 &&
      maximumThrustCapacityAcuator > ratedThrustLoad() &&
      maximumThrustCapacityAcuator > stallThrustLoad() &&
      section2RootDiameter() < rootDiameter() &&
      finalCalculateDr4 < rootDiameter() &&
      finalD4ValueCaculation < finishedDiaOfSpindle &&
      slendernessRationThreadedSection5 < 200 &&
      slendernessRationUnthreadedSection5 < 200 &&
      tensileStressInStem < yieldStrengthOfMaterial() &&
      (totalNoOfAnchorBoltRequired < quantityOfFastenrs ||
        (finalForceActingOnFrame() / quantityOfFastenrs) < (0.85 * permissiableShearStrengthOfTappedHole()))
      &&
      (safeWorkingForceOFresistance() > thrustLoadOnEachFastner ||
        permissibleShearStrengthOfNut() > loadOnEachFastnerNut ||
        permissibleShearStrengthOfNut() > loadOnEachFastner
      )

    ) {
      const userDetails = reactLocalStorage.getObject('userDetail');
      let formatedData = {
        ShutterDesignCalculationId: ShutterId,
        FrictionCoefficient: cofficientOfFriction,
        NumberOfStarts: numberOfStarts,
        SelectedActuatorType: selectedActuatorGearBox,
        RequiredStemAcceptanceForGearBoxAfterTurning: gearBoxStemAcceptance,
        GearBoxModelSelected: selectedGearboxModel,
        MaximumStemAcceptanceOfSelectedGearBox: gearBoxStemMaxAcceptance,
        MaximumThrustCapacityOfSelectedGearBox: gearBoxMaxThrustCapacity,
        MaximumTorqueCapacityOfSelectedGearBox: gearBoxMaxTorqueCapacity,
        OutPutDiameterOfSelectedGearBox: gearBoxOutputDiameter,
        GearRatioOfSelectedGearBox: gearBoxRatio,
        MechanicalAdvantageOfGearBox: gearBoxMechanicalAdvantage,
        TimeAvailableToOpenTheGate: availTimeOpenGate,
        ActuatorModelSelected: actuatorModel,  // Above to 'RPM of selected actuator model'
        RPMOfSelectedActuatorModel: actuatorModelRPM,
        ActuatorRatedTorqueAtGivenRPM: actuatorTorqueRPM,
        MaximumThrustCapacityOfSelectedActuatorModel: maximumThrustCapacityAcuator, //Below to 'Actuator rated torque at this RPM'    
        SpindleAcceptanceOfSelectedActuatorModel: spindleAcceptanceActuatorModel,
        ActuatorModelSelectedIs: actuatorModelSelected,  // this field 'Hence, Actuator model selected is'
        GearRatioBetweenBevelGearAndActuatorHandwheel: parseFloat(gearRatioBetweenBevelActuator),
        MechanicalEfficiencyOfBevel: mechanicalEfficiencyBevel,
        HandwheelRadiusOfSelectedActuator: actuatorHandwheelRadius,
        StallTorque: stallTorque,
        SelectedAbilityOfSpindle: standard,
        LengthOfColumnBetween2GuidesWorstCase: lengthOfColoum,
        LargestDistanceBetweenSpindleGuideThreaded: lengthOfColoum,
        ActuatorSpeed: acutatorSpeed,
        SelectedMaterialOfConstructionWallThimble: materialOfConstruction,
        QuantityOfFastenersWallThimble: quantityOfFastenrs,
        SelectedDiameterOfBoltsWallThimble: diaOfBolts,
        SelectedLengthOfBoltsWallThimble: frameMounting === "ON WALL" ? parseFloat(embededLengthConcrete) : parseFloat(lengthOfBoltOfWallTimble),
        SelectedMaterialOfBoltForYoke: materialOfSelectedBolt,
        SelectedDiameterOfBoltsForYoke: diameterOfBolt,
        SelectedLengthOfBoltsForYoke: parseFloat(lengthOfBolt),
        QuantityOfBoltOnPillarForYoke: quantityOfBoltOnPillar,
        SelectedSlideOrSluiceGateStandard: slideSluiceGateStandard,
        MaxAllowableLeakageSeatingHeadLessThan6M: onSeatingLessThan6Leakae,
        MaxAllowableLeakageOffSeatingHeadLessThan6M: onOffSeatingLessThan6Leakae,
        MaxAllowableLeakageSeatingHeadMoreThan6M: onSeatingMoreThan6Leakae,
        MaxAllowableLeakageOffSeatingHeadMoreThan6M: onOffSeatingMoreThan6Leakae,
        SelectedMaterialOfConstructionYoke: constructionMaterialOfYoke,
        SelectedYokeSection: youkeSection,
        SelectedYokeThickness: thicknessOfSection,
        LengthForAllowableDeflection: valueOfLSection11,
        CreatedBy: loggedInUserId(),
        loggedInUserId: loggedInUserId(),
        UnsupportedLengthForUnthreadedStemSection: parseFloat(unsupportedLengthForUnthreadedStem),
        HoistingCapacity: newhoistingCapacity,
        MaximumCriticalBucklingForce: finalCriticalBulkingForce,
        DoorWeight: weigth,
        OperatingTorque: operatingTorqueAtGearBox(),
        RatedTorqueForSelectedActuator: actuatorTorqueRPM,
        RootDiameterOfSpindle: rootDiameter(),
        NominalDiameterOfSpindle: diameterOfSpindle,
        SelectedFactorOfSafetyElectrical: factorOfSafetyElectrical,            //API change
        FactorOfSafetyCustomValue: factorOfSafetyCustomValue,     //API change
        SelectedStemDiameter: stemDiameterDD,     //API change
        DoorThickness: thicknessValue.value,
        ReserveCapacity: hoistingCapacityPercent.value
      }

      setCriticalBulkingForceValue(finalCriticalBulkingForce)
      setHoistingCapacity(hoistingCapacityValue);
      setWidth(intWidth)
      setLoader(true)
      if (isEditFlag || electricalDesignCreated) {
        formatedData = {
          ...formatedData,
          ElectricalOperationGateCalculationId: electricOperationId
        }
        updateElectricGate(formatedData, res => {
          setLoader(true)
          if (res.status === 200) {
            toastr.success('Electric Gate has been updated successfully.')
          }
          toggle('5')
        })
      } else {
        saveElectricalData(formatedData, res => {
          setLoader(false)
          if (res.status === 200) {
            setElectricDesignCreated(true)
            toastr.success('Data have been saved successfully.')
          }
          toggle('5')
        })
      }
      //     toggle("1");
      //   });
      // } else {
      //   saveElectricalData(formatedData, (res) => {
      //     if (res.status === 200) {
      //       toastr.success("Data have been saved successfully.");
      //     }
      //     toggle("5");
      //   });
      // }
    } else {
      toastr.warning('Your design is unsafe, Please check all the values once again.')
    }
  };

  const percentageChangeHandler = (val) => {
    setHoistingCapacityPercent({ label: val.label, value: val.value, percent: val.percent })
  }

  const getPercentByValue = (hoistingCapacityPercentage, value) => {
    const foundItem = hoistingCapacityPercentage.find(item => item.value === value);
    return foundItem ? foundItem.percent : null;
  };
  const weightLookup = {
    150: {
      4: 2.8,
      6: 3.9
    },
    200: {
      4: 4.0,
      6: 5.6
    },
    250: {
      4: 5.3,
      6: 7.6
    },
    300: {
      4: 7.2,
      6: 10.2
    },
    400: {
      4: 11.6,
      6: 17.2
    },
    450: {
      4: 15.1,
      6: 21.3
    },
    500: {
      4: 18.4,
      6: 25.8
    },
    600: {
      4: 27.0,
      6: 37.8
    },
    700: {
      5: 42.1,
      6: 48.8
    },
    800: {
      5: 53.0,
      6: 61.6
    },
    900: {
      5: 62.7,
      6: 80.0
    },
    1000: {
      5: 82.8,
      6: 97.2
    },
    1200: {
      6: 144.4
    }
  };

  const thicknessHandler = (val) => {
    setThicknessValue({ label: val.label, value: val.value })
    const weight = weightLookup[intWidth === intHeight ? intWidth : undefined][val.value];
    if (weight) {
      setWeightOfDoor(weight);
    }
  }

  return (
    <Container fluid className="cr-table-wrap">
      {isLoader && <Loader />}
      <div className="shutter-design">
        <div className="form-heading">
          <h2>Electrical Gate</h2>
        </div>
        <Row className="mb-3">
          <Col md="2">
            <p>DATED</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{moment(date).format("DD-MM-YYYY")}</p>
          </Col>
          {/* <Col md="4">
                        <p>GATE SIZE</p>
                    </Col>
                    <Col md="2">
                        <p>0</p>
                    </Col> */}
          <Col md="2">
            <p>CLIENT</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{client}</p>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="2">
            <p>LOCATION</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{location}</p>
          </Col>
          <Col md="2">
            <p>PROJECT</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{project}</p>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="2">
            <p>TAG NO.</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{tag_number}</p>
          </Col>
          <Col md="2">
            <p>REVISION NO.</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{rev_number}</p>
          </Col>
        </Row>
        {/* <Row>
                    <Col md="2">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>REFERENCE DRAWING NO.</p>
                    </Col>
                    <Col md="2">
                        <p>{'--------------'}</p>
                    </Col>
                </Row> */}
        {/* <Row>
                    <Col md="2">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>{''}</p>
                    </Col>
                   
                </Row> */}
        <Row className="mb-3">
          <Col md="2">
            <p>{""}</p>
          </Col>
          <Col md="4">
            <p>{""}</p>
          </Col>
          <Col md="2">
            <p>REVISION DATE</p>
          </Col>
          <Col md="1">:</Col>
          <Col md="3">
            <p>{rev_date ? moment(rev_date).format("DD-MM-YYYY") : '-'}</p>
          </Col>
        </Row>
        <hr />
        <form
          noValidate
          className="form"
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="off"
          onKeyPress={(e) => onKeyPress(e)}
        >
          {/* {rnderRow(
                        'TYPE OF CLOSURE',
                        '=',
                        <TeSelect
                            dataArray={rawFbcCbcData}
                            onChange={(val) => setSelectedFBCData(val)}
                        />
                    )} */}

          <Row className="mb-2 mt-4">
            <Col md="12">
              <div className={"page-heads"}>
                1). The force (Hoisting capacity) required to open the Penstock
                door at maximum water head: -
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Nominal opening width of Penstock (w)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{intWidth} {' mm'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="5">
              <p>{"Nominal opening height / depth of Penstock (h/d)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{intHeight}{' mm'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Seating water head acting on door  from the C. L."}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{intSeatingHead} {' m'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Unseating water head acting on door from the C.L."}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{intUnseatingHead ? intUnseatingHead : 0}{' m'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>
                {"Therefore Max. water head acting on door (H) from the C.L."}
              </p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{maxWaterHead()}{' m'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Density of sewage ( r )"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${densityOfSewage} Kg/m`}<sup>3</sup></p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Acceleration due to gravity  ( g )"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${gravity} m/s`}<sup>2</sup></p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3 max-">
            <Col md="5">
              <p>
                {"Co-efficient of friction between door and frame seals (f)"}
              </p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2" className="max-width-container">
              <TeInput
                name="co_efficientOfFriction"
                type="number"
                onChange={(e) => setCofficientOfFriction(e.target.value)}
                // value={cofficientOfFriction}
                register={register({ required: true })}
                errors={errors}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5" className="cr-mm-dimension">
              <p>
                {"Stem Diameter"}
              </p>
            </Col>
            <Col md="2" className="cr-mm-dimension text-right">
              <p>{"="}</p>
            </Col>
            <Col md="5" className="max-width-container">
              <TeSelect
                name="stemDiameterDD"
                register={register({ required: true })}
                errors={errors}
                dataArray={stemDiameterOptions}
                onChange={(val) => setStemDiameterDD(val)}
                undefinedValue={true}
                disabled={ciShutter}
              />
              {/* {errors.co_efficientOfFriction && "Input is required"} */}
            </Col>
          </Row>
          {noWeightOfDoor && <Row className="mb-3">
            <Col md="5" className="cr-mm-dimension">
              <p>
                {"Thickness"}
              </p>
            </Col>
            <Col md="2" className="cr-mm-dimension text-right">
              <p>{"="}</p>
            </Col>
            <Col md="1" className="max-width-container">
              <SearchableSelect
                name="thickness"
                register={register({ required: true })}
                errors={errors}
                dataArray={dimensions ? thicknessDropdown1 : dimensions2 ? thicknessDropdown3 : thicknessDropdown2}
                onChange={thicknessHandler}
                disabled={isViewFlag}
                value={thicknessValue}
              />
            </Col>
          </Row>}
          <Row className="mb-3">
            <Col md="5">
              <p>{"Weight of door (Md)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <div>
                {noWeightOfDoor ? (
                  <TeInput
                    name="weightOfDoor"
                    type="number"
                    value={weightOfDoor}
                    readOnly={noWeightOfDoor || isViewFlag}
                    register={register({ required: true })}
                    errors={errors}
                  />
                ) : (
                  <p>{weigth.toFixed(2)} {noWeightOfDoor ? "" : "kgs. (Approx)"}</p>
                )}
              </div>
            </Col>
            <Col md="3">
              <p></p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Nominal Diameter of spindle ( d )"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{diameterOfSpindle} {' mm'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Root Diameter of spindle ( dr )"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{checkForNull(rootDiameter().toFixed(2))} {' mm'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Distance between CL-PL"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              {/* <p>{intCL_PL}</p> */}
              <p>{distanceBetweenCLPL.toFixed(2)}{' mm'}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          {/* <Row className="mb-3">
            <Col md="5">
              <p>{"Additional length of spindle over platform"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${additionalLengthOfSpindle} mm ( Approx.)`}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row> */}
          <Row className="mb-3">
            <Col md="5">
              <p>{"Hence, total length of spindle"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="5">
              <p>{`${checkForNull(totalLengthOfSpindleCalc()).toFixed(0)}  mm ( Approx.)`}</p>
            </Col>
            {/* <Col md="2">
                            <p>{''}</p>
                        </Col> */}
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>
                {shaftSpindle === "TANDEM SPINDLE"
                  ? "Tandem shaft required therefore"
                  : "Single shaft required therefore"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{selectedSpindle() ? 1 : 2}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Weight of spindle for given diameter (Ms)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${weightOfSpindle().toFixed(0)} Kg`}</p>
            </Col>
            <Col md="3">
              <p>{""}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Formula for force required to open the door"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"P ="}</p>
            </Col>
            <Col md="5">
              <span><span>{"(w x 10"}</span><sup>-3</sup><span>{")x(d x 10"}</span><sup>-3</sup><span>{") x r x H x f + (1.5 x Md + Ms)"}</span></span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>{"P ="}</Col>
            <Col md="5">
              <p>{`${forceRequiredToOpenTheDoor().toFixed(2)} kgs.`}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>
                {"Hence force required to open the door / hoisting capacity"}
              </p>
            </Col>
            <Col md="2" className='text-right'>
              <b>{"P ="}</b>
            </Col>
            <Col md="5">
              <b>{`${checkForNull(hoistingCapacity().toFixed(2))} kN`}</b>
            </Col>
          </Row>
          <Row className="mb-2 mt-4">
            <Col md="12">
              <div className={"page-heads"}>
                2). Calculation of Spindle diameter: -
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>
                {
                  "The spindle diameter shall be determined by using the Euler’s Column Formula as under:-"
                }
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>{"P = "}</Col>
            <Col md="5">
              <p>C x π2 x E x A x (r/l)<sup>2</sup></p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Where,"}</p>
            </Col>
            <Col md="2"></Col>
            <Col md="2"></Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"P   = Axial load on stem (Hoisting capacity)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${forceRequiredToOpenTheDoor().toFixed(2)} Kgs.`}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <b>{shaftDisplayMessage()}</b>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"P = Axial load on each stem (Hoisting capacity)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${axialLoadOnEachStem()} Kgs.`}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${axialLoadOnEachStemCalculation()} Kgs.`}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>{"C = Defines end restrain conditions, to be taken as 2"}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <span>
                <span>{
                  "E = Modulus of elasticity to be taken as 2.0x10"}</span><sup>5</sup><span> {"Mpa. or   2.0x105 N/mm"
                  }</span><sup>2</sup>
              </span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>{"l = Length or span between supports in mm"}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>
                {"r = Radius of gyration in mm, for circular section =dr/4"}
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>{"dr = Root Diameter of spindle"}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>
                {"l/r = Slenderness ratio : to be taken as 200 for worst cases"}
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <p>A = Area of stem in mm<sup>2</sup> = π/4 x dr<sup>2</sup></p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {
                  "Substituting the above in Euler's column formula we arrive at :"
                }
              </p>
            </Col>
            <Col md="2" className='text-right'>
              {/* <p>{"dr ="}</p> */}
              <p>{""}</p>
            </Col>
            <Col md="5">
              {/* <span><span>{"SQRT {(P x 9.81 x (l/r)"}</span><sup>2</sup><span>{" x 4 ) / (C x π"}</span><sup>3</sup><span>{" x E)}"}</span></span> */}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Therefore, Root Diameter of spindle"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"dr ="}</p>
            </Col>
            <Col md="5">
              <span>
                <span><span>{"SQRT {(P x 9.81 x (l/r)"}</span><sup>2</sup><span>{" x 4 ) / (C x π"}</span><sup>3</sup><span>{" x E)}"}</span></span>
              </span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Root Diameter of spindle"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"dr ="}</p>
            </Col>
            <Col md="5">
              <span>
                <span>{"SQRT{(Hoisting Capx9.81x200x200x4)/(2x3.1415"}</span><sup>3</sup><span>{" x 2.0x10"}</span><sup>5</sup><span>{")}"}</span>
              </span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>
              <p>{`dr =`}</p>
            </Col>
            <Col md="5">
              <p>{`${checkForNull(section2RootDiameter().toFixed(0))} mm`}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"However we consider Root Diameter of spindle"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"dr ="}</p>
            </Col>
            <Col md="5">
              <p>{`${checkForNull(rootDiameter().toFixed(0))} mm`}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <b>{spindleDiameterAlertMessage()}</b>
            </Col>
          </Row>

          <Row className="mb-2 mt-4">
            <Col md="12">
              <div className={"page-heads"}>
                3). Selection of Manual operating mechanism: -
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="12">
              <b>{"A. Calculation of stem factor"}</b>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Nominal Diameter of selected spindle"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${diameterOfSpindle}`}{' mm'}</p>
            </Col>
            <Col md="3">{ }</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Finished Diameter of this spindle (dm)"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${finishedDiaOfSpindle}`}{' mm'}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{`${finishedDiaOfSpindleDividedByThousand}`}{' m'}</p>
            </Col>
            <Col md="3"></Col>
          </Row>

          <Row className="mb-3">
            <Col md="5">
              <p>{"Thread Pitch"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <p>{threadPitch()}{' mm'}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Number of starts"}</p>
            </Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
            </Col>
            <Col md="2">
              <TeInput
                name="numberOfStarts"
                type="number"
                onChange={(e) => setNumberOfStarts(e.target.value)}
                value={numberOfStarts}
                readOnly={isViewFlag}
                register={register({ required: true })}
                errors={errors}
              />
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Lead"}</p>
            </Col>
            <Col md="2" className='text-right'>L =</Col>
            <Col md="5">
              <p>{"Thread pitch  x No. of starts"}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>
              <p>{"="}</p>
              <p>{"L ="}</p>
            </Col>
            <Col md="5">
              <p>{`${leadValue().toFixed(2)} mm`}</p>
              <p>{`${finalLeadValue().toFixed(4)} m`}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">Pitch Spindle Diameter</Col>
            <Col md="2" className='text-right'>dp =</Col>
            <Col md="2">{checkForNull(pitchSpindleDiameter()).toFixed(4)} m</Col>
            <Col md="3"></Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">Coefficient of friction    <TooltipCustom /></Col>
            <Col md="2" className='text-right'>μ =</Col>
            <Col md="5">{frictionCofficient.toFixed(3)}</Col>
          </Row>

          <Row className="mb-3">
            <Col md="12">
              <p>
                <img src={require("../../assests/images/stemFactor.PNG")} />
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">Hence Stem Factor</Col>
            <Col md="2" className='text-right'>SF=</Col>
            <Col md="2">{stemFactor().toFixed(4)} m</Col>
            <Col md="3"></Col>
          </Row>

          <Row className={"mt15 mb15"}>
            <Col md="12">
              <b>
                B. Calculation of Torque at Drive Nut ( Operating torque, To)
              </b>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="7">
              Reserve Capacity for thread inefficiency, mis-alignment,
              manufacturing inaccuracy etc ({getPercentByValue(hoistingCapacityPercentage, hoistingCapacityPercent.value)}% extra).
            </Col>
            <Col md="1" className="max-width-container">
              <SearchableSelect
                name="hoistingCapacityPercent"
                register={register({ required: true })}
                errors={errors}
                dataArray={hoistingCapacityPercentage}
                onChange={percentageChangeHandler}
                data-extra={hoistingCapacityPercentage.percent}
                disabled={isViewFlag}
                value={hoistingCapacityPercent}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">Hoisting capacity</Col>
            <Col md="2" className='text-right'>=</Col>
            <Col md="5">P x {hoistingCapacityPercent.value}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>=</Col>
            <Col md="5">{checkForNull(newhoistingCapacity.toFixed(2))} KN</Col>
            {/* <Col md="1">kN</Col> */}
          </Row>
          <Row className="mb-3">
            <Col md="5">
              {/* Operating torque(To) */}
              {shaftSpindle === 'SINGLE SPINDLE' ? "Operating torque (To)" : "Operating torque at drive nut of each stem (To)"}
            </Col>
            <Col md="2" className='text-right'>=</Col>
            <Col md="5">Hoist. Cap. x Stem factor</Col>
          </Row>

          <Row className="mb-3">
            <Col md="5"></Col>
            <Col md="2" className='text-right'>
              <p>=</p>
            </Col>
            <Col md="5">
              <p>{checkForNull(operatingTorqueAtGearBox().toFixed(3))} kNm</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              {/* Therefore, operating torque (To) */}
              {/* =IF(D18=D899,"   Hence Operating torque (To)","   Hence Operating torque at drive nut of each stem (To)") */}
              {shaftSpindle === 'SINGLE SPINDLE' ? "Hence Operating torque (To)" : "Hence Operating torque at drive nut of each stem (To)"}
            </Col>
            <Col md="2" className='text-right'>
              <p>=</p>
            </Col>
            <Col md="5">
              {checkForNull(finalOperatingTorqueAtGearBox.toFixed(1))} Nm
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">To</Col>
            <Col md="2" className='text-right'>
              <p>=</p>
            </Col>
            <Col md="5">
              {checkForNull(
                finalOperatingTorqueAtGearBoxDividedByGravity.toFixed(2)
              )}{" "}
              Kgs.m
            </Col>
          </Row>

          {/* Additional C section in electrical start */}
          <Row className={"mb-3"}>
            <Col md="12" className={"mb15"}>
              <b>
                C. Selection of operating mechanism comprising of Actuator /
                Actuator + Gearbox
              </b>
            </Col>

            <Col md="12" className={"mb15"}>
              <p>
                {
                  "Whether only an actuator is to be used or an actuator is to be used with a gearbox is decided based on operating Torque. Generally an actuator is used with gear box in situations when the operating torque is high and tandem shaft arrangement."
                }
              </p>
            </Col>
          </Row>

          {rnderRow(
            "In this case we select",
            ":",
            <TeSelect
              name="SelectedActuatorGearBox"
              register={register({ required: true })}
              errors={errors}
              dataArray={actuatorGearBoxData}
              undefinedValue={true}
              onChange={(val) => setSelectedActuatorGearBox(val)}
              disabled={isViewFlag}
              className="select-box"
            />
          )}

          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Selection of Gear box :"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{gearBoxSelection() ? "" : "Not Required"}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Required stem acceptance for Gear box"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>
                {gearBoxSelection()
                  ? `${checkForNull(rootDiameter().toFixed(2))} mm`
                  : ""}
              </p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Required stem acceptance for Gear box after turning"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxStemAcceptance"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setGearBoxStemAcceptance(e.target.value)}
                value={gearBoxStemAcceptance}
                readOnly={isViewFlag}

              />
            </Col>
            <Col md="3" className="cr-mm-dimension">
              {"mm"}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Required Thrust capacity for Gear box"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>
                {gearBoxSelection()
                  ? `${checkForNull(newhoistingCapacity.toFixed(2))} kN`
                  : ""}
              </p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Required Operating torque for Gear box"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>
                {gearBoxSelection()
                  ? `${checkForNull(
                    finalOperatingTorqueAtGearBox.toFixed(2)
                  )} Nm`
                  : ""}
              </p>
            </Col>
          </Row>

          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Gearbox model selected "}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="1">
              <p>{gearBoxSelection() ? "Model No:-" : "Not Required"}</p>
            </Col>
            <Col md="2">
              <TeInput
                name="gearBoxModelSelected"
                register={register({ required: true })}
                errors={errors}
                type="text"
                onChange={(e) => setSelectedGearboxModel(e.target.value)}
                value={selectedGearboxModel}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="2">
              <b>{"Gearbox Selection"}</b>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Maximum stem acceptance of selected Gear box in mm"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxMaxStemAcceptance"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setGearBoxStemMaxAcceptance(e.target.value)}
                value={gearBoxStemMaxAcceptance}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{maxStemAcceptanceOKAlert()}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Maximum thrust capacity of selected Gear box in kN"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxMaxThrustCapacity"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setgearBoxMaxThrustCapacity(e.target.value)}
                value={gearBoxMaxThrustCapacity}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{maxThrustCapacityOKAlert()}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Maximum torque capacity of selected Gear box in Nm"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxMaxTorqueCapacity"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setgearBoxMaxTorqueCapacity(e.target.value)}
                value={gearBoxMaxTorqueCapacity}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{maxTorqueCapacityOKAlert()}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Output diameter of selected Gear box in mm"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxOutputDiameter"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setgearBoxOutputDiameter(e.target.value)}
                value={gearBoxOutputDiameter}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{""}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <b>{"Selection of actuator model:"}</b>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Gear Ratio of selected Gear box"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxRatio"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setgearBoxRatio(e.target.value)}
                value={gearBoxRatio}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{""}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{"Mechanical advantage of Gear box"}</p>
            </Col>
            <Col md="2" className='text-right'>{"M.A. ="}</Col>
            <Col md="2">
              <TeInput
                name="gearBoxMechanicalAdvantage"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setgearBoxMechanicalAdvantage(e.target.value)}
                value={gearBoxMechanicalAdvantage}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">{""}</Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{inputShaftTorqueSpindle()}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{operatingTorqueDriveNut()}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              {checkForNull(
                finalOperatingTorqueAtGearBox / gearBoxMechanicalAdvantage
              ).toFixed(1)} {" Nm"}
            </Col>
            <Col md="3"></Col>
          </Row>

          {shaftSpindle !== "SINGLE SPINDLE" &&
            <Fragment>
              <Row className={"mb-3"}>
                <Col md="5">
                  Therefore,Input shaft torque considering both spindle (in N-m)
                  { }
                </Col>
                <Col md="2" className='text-right'>{"="}</Col>
                <Col md="5">
                  <p>{"Input torque at Gear box on each spindle x 2"}</p>
                </Col>
              </Row>
              <Row className={"mb-3"}>
                <Col md="5">
                  <p>{""}</p>
                </Col>
                <Col md="2" className='text-right'>{"="}</Col>
                <Col md="5">
                  <p>{checkForNull(inputShaftTorqueBlankReturn()).toFixed(1)}</p>
                </Col>
              </Row>
            </Fragment>
          }
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Torque required at actuator ( in N-m)"}</p>
            </Col>
            <Col md="2" className='text-right'>{"Tol="}</Col>
            <Col md="2">
              <p>{torqueRequiredAcuator().toFixed(1)}{" Nm"}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Thrust required at actuator ( in kN)"}</p>
            </Col>
            <Col md="2" className='text-right'>{"P ="}</Col>
            <Col md="2">
              <p>{thrustRequiredAcuator().toFixed(1)}{" kN"}</p>
            </Col>
            <Col md="3"></Col>
          </Row>

          <Row className={"mb-3"}>
            <Col md="5">
              <p>{clouserActualHeight()}{" mm"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{clouserActualHeightCalculation()}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Lead ( pitch x number of starts )"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{`${leadValue().toFixed(2)} mm`}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Number of turns of drive nut to open gate"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{`Length of gate opening / Lead`}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{`${numberOfTurnsOpenGate().toFixed(0)} Nos.`}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Therefore, Required nos. of Revolution of actuator"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{`${(numberOfTurnsOpenGate() * gearBoxRatio).toFixed(0)} Nos.`}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {"Time available to open the gate as per specs/actuator data"}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="availTimeOpenGate"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setavailTimeOpenGate(e.target.value)}
                value={availTimeOpenGate}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3" className="cr-mm-dimension">
              {"Min."}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Therefore, Minimum actuator revolutions required/minute"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{`${minimumActuatorRevolutions()} RPM`}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Actuator model selected "}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="actuatorModel"
                register={register({ required: true })}
                errors={errors}
                type="text"
                onChange={(e) => setActuatorModel(e.target.value)}
                value={actuatorModel}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3">
              <b>{"Actuator Selection"}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"RPM of selected actuator model"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="actuatorModelRPM"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setactuatorModelRPM(e.target.value)}
                value={actuatorModelRPM}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="2" className="cr-mm-dimension">
              {"RPM"}
            </Col>
            <Col md="1" className="cr-mm-dimension">
              <b>{actuatorModelOK()}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Actuator rated torque at this RPM"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="actuatorTorqueRPM"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setactuatorTorqueRPM(e.target.value)}
                value={actuatorTorqueRPM}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="2" className="cr-mm-dimension">
              {"Nm"}
            </Col>
            <Col md="1" className="cr-mm-dimension">
              <b>{actuatorTorqueOK()}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {
                  "Maximum thrust taking capacity of selected actuator model is "
                }
              </p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="maximumThrustCapacity"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) =>
                  setmaximumThrustCapacityAcuator(e.target.value)
                }
                value={maximumThrustCapacityAcuator}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="2" className="cr-mm-dimension">
              {"kN"}
            </Col>
            <Col md="1" className="cr-mm-dimension">
              <b>{maximumThrustCapacityAcuatorOK()}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Spindle acceptance of selected actuator model is"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="spindleAcceptanceActuatorModel"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) =>
                  setspindleAcceptanceActuatorModel(e.target.value)
                }
                value={spindleAcceptanceActuatorModel}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="2" className="cr-mm-dimension">
              {"mm"}
            </Col>
            <Col md="1" className="cr-mm-dimension">
              <b>{spindleAcceptanceActuatorModelOK()}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Hence, Actuator model selected is "}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <TeInput
                name="actuatorModelSelected"
                register={register({ required: true })}
                errors={errors}
                type="text"
                onChange={(e) => setActuatorModelSelected(e.target.value)}
                value={actuatorModelSelected}
                readOnly={isViewFlag}
              />
            </Col>
          </Row>
          {/* Additional C section in electrical close */}

          {/* Additional D section in electrical close */}

          <Row className={"mb-3"}>
            <Col md="12" className={"mb15"}>
              <b>
                D. Verification of suitability of selected electric actuator to
                manually crack open the gate with effort not exceeding one and
                half times the permissible gate operating effort of 18 Kgs.
              </b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{torqueAtGearBoxOutput()}</p>
            </Col>
            <Col md="2" className='text-right'>{"To ="}</Col>
            <Col md="2">
              <p>{checkForNull(finalOperatingTorqueAtGearBox.toFixed(2))}{" Nm"}</p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{VerificationGearBox()}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{VerificationGearBoxDisplay()}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <p>
                {checkForNull(
                  (
                    finalOperatingTorqueAtGearBox / gearBoxMechanicalAdvantage
                  ).toFixed(2)
                )}{" Nm"}
              </p>
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Torque at Drive nut of actuator "}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{torqueDriveNutActuator()}</p>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <p>{torqueDriveNutActuatorCalculation().toFixed(2)} {" Nm"}</p>
            </Col>
          </Row>

          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Gear ratio between bevel gear & actuator handwheel"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5" className="max-width-container">
              <TeInput
                name="gearRatioBetweenBevelActuator"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) =>
                  setgearRatioBetweenBevelActuator(e.target.value)
                }
                value={gearRatioBetweenBevelActuator}
                readOnly={isViewFlag}
              />
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Mechanical Efficiency of bevel"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5" className="max-width-container">
              <TeInput
                name="mechanicalEfficiencyBevel"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setmechanicalEfficiencyBevel(e.target.value)}
                value={mechanicalEfficiencyBevel}
                readOnly={isViewFlag}
              />
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {"Therefore,Mechanical advantage of bevel gear for handwheel"}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">{bevelGearMechanicalAdvantage().toFixed(2)}</Col>
          </Row>

          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Handwheel radius of selected actuator ( Cr)"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              <TeInput
                name="actuatorHandwheelRadius"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setactuatorHandwheelRadius(e.target.value)}
                value={actuatorHandwheelRadius}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3" className="cr-mm-dimension">
              {"mm"}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12">{""}</Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{""}</Col>
            <Col md="5">{"Torque at Drive nut of actuator"}</Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {"Effort required for manual operation of actuator handwheel"}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              {"-------------------------------------------------"}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{""}</Col>
            <Col md="5">
              {"Handwheel radius x  Mech. advantage of Bevel Gear"}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12">{""}</Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">{requiredEffortActuatorHandwheel().toFixed(2)}{" N"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">
              {checkForNull(requiredEffortActuatorHandwheel() / 9.81).toFixed(
                2
              )}{" Kgs."}
            </Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12">
              <b>{verificationSuitabilityAlert()}</b>
            </Col>
          </Row>
          {/* Additional D section in electrical close */}
          {/* Additional E section in electrical close */}
          <Row className={"mb-3"}>
            <Col md="12" className={"mb15"}>
              <b>
                E. Thrust load at rated torque of actuator and Thrust load with
                actuator in stall condition.
              </b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Operating torque (To1)"}</p>
            </Col>
            <Col md="2" className='text-right'>{"Tol="}</Col>
            <Col md="2">{torqueRequiredAcuator().toFixed(2)}{" Nm"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Rated torque (Tr) for selected actuator from catalogue"}</p>
            </Col>
            <Col md="2" className='text-right'>{"Tr ="}</Col>
            <Col md="2">{actuatorTorqueRPM}{" Nm"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {"Stall torque (Ts) { From Actuator manufacturer data sheet }"}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"Ts ="}</Col>
            <Col md="2">
              <TeInput
                name="stallTorque"
                register={register({ required: true })}
                errors={errors}
                type="number"
                onChange={(e) => setstallTorque(e.target.value)}
                value={stallTorque}
                readOnly={isViewFlag}
              />
            </Col>
            <Col md="3" className="cr-mm-dimension">
              {"Nm"}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12">
              {
                "The stall Thrust load can come in play when the wedges engage at the end of stroke. "
              }
            </Col>

            <Col md="5">
              <p>{"Hence in this condition the stall thrust load will be"}</p>
            </Col>
            <Col md="2" className='text-right'>{"Ps ="}</Col>
            <Col md="5">{"P x Ts / To1"}</Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{""}</p>
            </Col>
            <Col md="2" className='text-right'>{"Ps ="}</Col>
            <Col md="2">{stallThrustLoad().toFixed(2)}{" kN"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12">
              {
                "The rated thrust load is generated when the torque switch is set to maximum torque of actuator."
              }
            </Col>

            <Col md="5">
              <p>
                {"Hence, in this condition the rated thrust load will be  "}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"Pr ="}</Col>
            <Col md="5">{"P x Tr / To1"}</Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"where P = operating thrust or hoisting force "}</p>
            </Col>
            <Col md="2" className='text-right'>{"P ="}</Col>
            <Col md="2">{thrustRequiredAcuator().toFixed(1)}{" kN"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Therefore the rated thrust load generated by actuator"}</p>
            </Col>
            <Col md="2" className='text-right'>{"Pr ="}</Col>
            <Col md="2">{ratedThrustLoad().toFixed(2)}{" kN"}</Col>
            <Col md="3"></Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="12" className={"mt15 mb15"}>
              {""}
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>
                {"The Maximum thrust taking capacity of selected actuator is"}
              </p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="2">{checkForNull(maximumThrustCapacityAcuator)}{" kN"}</Col>
            <Col md="3"></Col>

            <Col md="12">
              <b>{thrustLoadAlertMessage()}</b>
            </Col>
          </Row>
          {/* Additional E section in electrical close */}
          {/* Additional F section in electrical close */}
          <Row className={"mb-3"}>
            <Col md="12" className={"mb15"}>
              <b>F. Final model of selected Actuator & Gear box: -</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Actuator model selected"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <b>{actuatorModelSelected}</b>
            </Col>
          </Row>
          <Row className={"mb-3"}>
            <Col md="5">
              <p>{"Gearbox model selected"}</p>
            </Col>
            <Col md="2" className='text-right'>{"="}</Col>
            <Col md="5">
              <b>
                {gearBoxSelection() ? selectedGearboxModel : "Not Required"}
              </b>
            </Col>
          </Row>
          {/* Additional F section in electrical close */}
          <Row className={"mb-3"}>
            {renderHeadingType2(
              "4). The ability of the spindle to withstand buckling: -"
            )}
            <Col md="1"></Col>
            <Col md="4">
              <TeSelect
                name="abilityOfSpindleStandard"
                register={register({ required: true })}
                errors={errors}
                dataArray={[
                  {
                    label: "As Per AWWA C560 standard",
                    value: "As Per AWWA C560 standard",
                  },
                  {
                    label: "As Per AWWA C561/C562 standard",
                    value: "As Per AWWA C561/C562 standard",
                  },
                  {
                    label: "As Per BS7775 standard",
                    value: "As Per BS7775 standard",
                  },
                  {
                    label: "As Per IS 13349 standard",
                    value: "As Per IS 13349 standard",
                  }
                ]}
                // As Per AWWA C560 standard		
                // As Per AWWA C561/C562 standard		
                // As Per BS7775 standard		
                // As Per IS 13349 standard		

                onChange={(val) => setStandard(val)}
                undefinedValue={true}
                disabled={isViewFlag}
              />
            </Col>
          </Row>

          {renderSingleColoumRow(
            standard === "As Per AWWA C560 standard"
              ? "Where Electric Motor driven actuators are used, the stem shall be designed for compression load caused by 1.25 times the output thrust of the unit in stalled motor condition."
              : standard === "As Per AWWA C561/C562 standard"
                ? "Where Electric Motor driven actuators are used, the stem shall be designed for compression load caused by 1.5 times the output thrust of the unit in stalled motor condition."
                : standard === "As Per BS7775 standard"
                  ? "Where Electric Motor driven actuators are used, the stem shall be designed for compression load caused the output thrust of the unit in stalled motor condition."
                  : "Where Electric Motor driven actuators are used, the stem shall be designed for compression load caused by 1.25 times the output thrust of the unit in stalled motor condition."
          )}
          {rnderRow(
            // "Output Thrust of this actuator in stalled motor condition"
            standard === "As Per AWWA Standard"
              ? "Output Thrust of this actuator in stalled motor condition"
              : standard === "As Per BS7775 Standard"
                ? "Output Thrust of this actuator in rated motor condition"
                : "Output Thrust of this actuator in stalled motor condition.",
            "=",
            `${stallThrustLoad().toFixed(2)} kN`
          )}
          {rnderRowFormula(
            standard === "As Per AWWA C560 standard"
              ? "Maximum Critical buckling force on stem in line with AWWA C560"
              : standard === "As Per AWWA C561/C562 standard"
                ? "Maximum Critical buckling force on stem in line with AWWA C561/C562"
                : standard === "As Per BS7775 standard"
                  ? "Maximum Critical buckling force on stem in line with BS 7775"
                  : "Maximum Critical buckling force on stem in line with IS 13349",
            "=",
            standard === "As Per AWWA C560 standard"
              ? "1.25 x Output Thrust in stalled motor condition  x Mechanical"
              : standard === "As Per AWWA C561/C562 standard"
                ? "1.5 x Output Thrust in stalled motor condition  x Mechanical"
                : standard === "As Per BS7775 standard"
                  ? "Output Thrust in stalled motor condition  x Mechanical"
                  : "1.25 x Output Thrust in stalled motor condition  x Mechanical"
          )}
          {renderSingleColoumRow("advantage of gear box")}

          {rnderRow(
            standard === "As Per AWWA C560 standard"
              ? "Maximum Critical buckling force on stem in line with AWWA C560"
              : standard === "As Per AWWA C561/C562 standard"
                ? "Maximum Critical buckling force on stem in line with AWWA C561/C562"
                : standard === "As Per BS7775 standard"
                  ? "Maximum Critical buckling force on stem in line with BS 7775"
                  : "Maximum Critical buckling force on stem in line with IS 13349",
            "=",
            `${criticalBulkingForce().toFixed(2)} kN`
          )}
          {rnderRow("", "=", `${finalCriticalBulkingForce.toFixed(2)} N`)}

          {rnderRow(
            shaftSpindle === "TANDEM SPINDLE" ? "Max.Critical buckling force on each stem in case of tandem shaft" : ""
            , "Pcr1 ="
            , `${checkForNull(MaxCriticalCalc()).toFixed(2)} N`)}

          {renderSingleColoumRow(
            "To determine whether the compressive load on the spindle is within safe limits it is necessary to calculate the critical load which would cause the spindle to buckle. The spindle can be considered to be a slender column for which the Euler formula applies, whereby :"
          )}
          {rnderRow(
            "The critical load which would cause the column to buckle",
            "Pcr =",
            <span><span>{'(Π)'}</span><sup>2</sup><span>{' x  C x  E x I / (Lx)'}<sup>2</sup></span></span>
          )}
          {renderSingleColoumRow("Where,")}
          {rnderRow("The end condition constant ( worst case) C", "=", 2.0)}
          {rnderRow("Young's Modulus of Elasticity E", "=", <p>200000.0 N/mm<sup>2</sup></p>)}
          {rnderRow("Section modulus I", "=", <span><span>{'(Π) x (Dr)'}</span><sup>4</sup><span> {'/ 64'}</span></span>)}
          {rnderRow(
            "Length of column between 2 guides ( worst case) Lx",
            "=",
            <TeInput
              name="lengthOfColoum"
              register={register({ required: true })}
              errors={errors}
              type="number"
              onChange={(e) => setLengthOfColoum(e.target.value)}
              value={lengthOfColoum}
              readOnly={isViewFlag}
            />,
            "mm"
          )}
          {rnderRowMinSpace(
            "Substituting above values",
            <span><span>=</span><span> Dr</span><sup>4</sup></span>,
            calculateDr4().toFixed(2),
            <span>mm<sup>4</sup></span>
          )}
          {rnderRow("", "Dr =", `${finalCalculateDr4.toFixed(2)} mm`)}

          <Row md="12">
            <Col>
              {finalCalculateDr4 < rootDiameter() ? (
                <b>
                  {
                    "Since selected spindle diameter is more than the spindle diameter required to withstand Buckling, the design is safe."
                  }
                </b>
              ) : (
                <b>{<p className='error'>Design is Un-safe, Please re-design.</p>}</b>
              )}
            </Col>
          </Row>
          {rnderRow(
            `Unsupported length for unthreaded stem section between 2 guides ${" "} ( worse case) `,
            "LX = ",
            <TeInput
              name="unsupportedLengthForUnthreadedStem"
              register={register({ required: true })}
              errors={errors}
              type="number"
              onChange={(e) =>
                setUnsupportedLengthForUnthreadedStem(e.target.value)
              }
              value={unsupportedLengthForUnthreadedStem}
              readOnly={isViewFlag}
            />,
            "mm   ( Refer GA drawing )"
          )}
          {rnderRowMinSpace(
            "Substituting above values",
            <span><span>D</span><sup>4</sup> = </span>,
            D4ValueCaculation().toFixed(0),
            <span><span>mm</span><sup>4</sup></span>
          )}
          {rnderRowMinSpace("", "D = ", finalD4ValueCaculation.toFixed(2), <span>mm</span>)}
          <Row md="12">
            <Col>
              {finalD4ValueCaculation < finishedDiaOfSpindle ? (
                <b>
                  {
                    "Since selected spindle diameter is more than the spindle diameter required to withstand Buckling, the design is safe."
                  }
                </b>
              ) : (
                <b style={{ color: "red" }}>
                  {<p className='error'>Design is Un-safe, Please re-design.</p>}
                </b>
              )}
            </Col>
          </Row>
          {renderHeading("5) Stem Guide Spacing: -")}
          {renderSingleColoumRow(
            standard === "As Per AWWA Standard"
              ? "Firstly,the slenderness ratio can be checked according to AWWA, the slenderness ratio should not exceed 200."
              : standard === "As Per BS7775 Standard"
                ? "Firstly,the slenderness ratio can be checked according to BS 7775, the slenderness ratio should not exceed 200."
                : "Firstly,the slenderness ratio can be checked according to IS 13349, the slenderness ratio should not exceed 200."
          )}
          {rnderRow(
            "Largest distance between spindle guides ( unthreaded) L1",
            "=",
            `${unsupportedLengthForUnthreadedStem} mm`
          )}
          {rnderRow(
            "Largest distance between spindle guides (threaded) L2",
            "=",
            // <TeInput
            //     name='distanceBetweenSpindleGuides'
            //     register={register({required: true})}
            // errors = { errors }
            //     type='number'
            //     onChange={(e) => setDistanceBetweenSpindleGuides(e.target.value)}
            //     value={distanceBetweenSpindleGuides}
            // />
            lengthOfColoum + " m"
          )}
          {rnderRow(
            "Nominal Diameter of spindle ( unthreaded) d",
            "=",
            `${diameterOfSpindle} mm`
          )}
          {rnderRow(
            "Root Diameter of spindle  ( threaded) dr",
            "=",
            `${checkForNull(rootDiameter().toFixed(2))} mm`
          )}
          {rnderRow(
            "For slenderness ratio on unthreaded section of spindle : SR",
            "=",
            `L1 x 4/d`
          )}
          {rnderRow("", "SR =", slendernessRationUnthreadedSection5.toFixed(2))}
          {rnderRow(
            "For slenderness ratio on threaded section of spindle : SR",
            "=",
            `L2 x 4/dr`
          )}
          {rnderRow("", "SR =", slendernessRationThreadedSection5.toFixed(2))}
          {renderSingleColoumRow(
            slendernessRationThreadedSection5 < 200 &&
              slendernessRationUnthreadedSection5 < 200 ? (
              <b>
                'Since these two values are less than 200, hence tem guide
                spacing is in line with requirement.'
              </b>
            ) : (
              <b><p className='error'>Design is Un-safe, Please re-design.</p></b>
            )
          )}

          {rnderRow("Now, Selected stem diameter checked for tension.")}
          {rnderRow("Root dia. of stem", "=", checkForNull(rootDiameter()).toFixed(2) + " mm")}
          {rnderRow("Tensile area of stem", "=", <span>Π dr<sup>2</sup> /4</span>)}
          {rnderRowMinSpace("", "=", tensileAreaOfStem.toFixed(2), <span>mm<sup>2</sup></span>)}
          {rnderRow("Tensile stress in stem", "=", tensileStressInStem.toFixed(2) + " Mpa",
            <div><Row><Col>Factor Of Safety = </Col>
              <Col> <TeSelect
                name="factorOfSafetyElectrical"
                register={register({ required: true })}
                errors={errors}
                dataArray={factorOfSafety}
                onChange={(val) => setFactorOfSafetyElectrical(val)}
                // undefinedValue={true}
                disabled={isViewFlag}
              /></Col></Row>
            </div>)}

          {/* =IF(OR(AT185=AQ518,AT185=AQ519),"Tensile strength of stem material","Yeild strength of stem material") */}
          {/* (standard==='As Per AWWA C560 standard'||standard==='As Per AWWA C561/C562 standard')
          ?'Tensile strength of stem material'
          :'Yeild strength of stem material' */}

          {/* =IF(OR(AT185=AQ518,AT185=AQ519),"Tensile strength of stem material","Yeild strength of stem material") */}
          {rnderRow(
            (standard === 'As Per AWWA C560 standard' || standard === 'As Per AWWA C561/C562 standard')
              ? 'Tensile strength of stem material'
              : 'Yeild strength of stem material',
            "=",
            // =IF(OR(AT185=AQ518,AT185=AQ519),IF(AY237="CUSTOM",G527/AY238,G527/5),IF(AY237="CUSTOM",H527/AY238,H527))
            checkForNull(yieldStrengthOfMaterial()).toFixed(2) + " Mpa",
            factorOfSafetyElectrical === "CUSTOM" ? (
              <div>
                <Row><Col>FOS = </Col>
                  <Col>
                    <TeInput
                      name="factorOfSafetyCustomValue"
                      type="number"
                      onChange={(e) => setFactorOfSafetyCustomValue(e.target.value)}
                      value={factorOfSafetyCustomValue}
                    // readOnly={isViewFlag}
                    />
                  </Col>
                </Row>
              </div>) : (null))}
          {renderSingleColoumRow(tensileStressInStem < yieldStrengthOfMaterial() ? (
            <b>
              'Since tensile stress is less than the yield strength of stem material, the design is safe.'
            </b>
          ) : (
            <b><p className='error'>Design is Un-safe, Please re-design.</p></b>
          )
          )}
          {renderHeading(
            "6). The locking characteristics of the operating spindle: -"
          )}
          {renderSingleColoumRow(
            "To determine whether the spindle is self locking or whether it is statically or dynamically reversible, the following calculations are made."
          )}
          {rnderRow(
            'For the screw to be self locking', "Pitch <", "Π x S x dm"
          )}
          {renderSingleColoumRow(
            "For Stainless Steel spindle provided with stub acme thread,"
          )}
          {rnderRow(
            "Static friction coefficient, S1",
            "=",
            staticFrictionCoefficient
          )}
          {rnderRow(
            "Dynamic friction coefficient ,S2",
            "=",
            dynamicFrictionCoefficient
          )}
          {rnderRow(
            "Finished Diameter of this spindle (dm)",
            "=",
            `${finishedDiaOfSpindle} mm`
          )}
          {rnderRow("Thread depth (td)", "=", "0.3 x Thread pitch")}
          {rnderRow("Therefore, Thread depth (td)", "=", `${checkForNull(threadDepth).toFixed(2)} mm`)}
          {rnderRow(
            "Effective diameter (de) = (dm-td)",
            "=",
            `${checkForNullNegative(effectiveDiameter).toFixed(2)} mm`
          )}
          {rnderRow(
            // "Checking for statically reversible:",
            "To check for statically reversible:",
            "Π x S x de =",
            `${staticallyReversibleCondition.toFixed(2)}`
          )}
          {rnderRow(
            // "Checking for dynamically reversible:",
            "To check for dynamically reversible:",
            "Π x S x de =",
            `${dynamicallyReversibleCondition.toFixed(2)}`
          )}
          {renderSingleColoumRow(
            <b>
              'As both of the values are more than the thread pitch, hence the
              spindle will be self locking.'
            </b>
          )}
          {renderHeading(
            "7).	The opening / closing speed of the penstock door: -"
          )}
          {rnderRow(
            "Actuator speed (rpm)",
            "Sa =",
            <TeInput
              name="acutatorSpeed"
              register={register({ required: true })}
              errors={errors}
              type="number"
              onChange={(e) => setAcutatorSpeed(e.target.value)}
              value={acutatorSpeed}
              readOnly={isViewFlag}
            />
          )}
          {rnderRow("Spindle Lead  L", "=", leadValue().toFixed(2))}
          {rnderRow(
            "Gearbox ratio if Gearbox-electrical acuator combination required  Gr",
            "=",
            gearBoxRatio
          )}
          {rnderRow("For door speed : Ds", "=", "Sa x L / Gr")}
          {rnderRow("", "Ds =", `${doorSpeed().toFixed()} mm/min`)}

          <p>
            {frameMounting === "ON WALL" ? (
              <div>
                {renderHeading(
                  "8). The suitability of the selected foundation bolts / fastener to fasten the frame to the civil wall: -"
                )}
                {renderHeading(
                  "Now we check for suitability of the selected foundation bolts to fasten the Penstock to the civils: -"
                )}
                {renderHeading(
                  "We check for uprooting of anchor bolt/ Fasteners for uprooting at given unseating/seating water head."
                )}

                {rnderRow(
                  "Unseating water force acting on frame",
                  "=",
                  "Area x water head"
                )}
                {rnderRow("", "=", "W x H x water head")}
                {rnderRow("", "=", `${checkForNull(forceActingOnFrame()).toFixed(2)} Kgs.`)}
                {rnderRow(
                  "",
                  "=",
                  `${finalForceActingOnFrame().toFixed(2)} kN`
                )}
                {rnderRow(
                  "Material of consruction of wall thimble",
                  "=",
                  <TeSelect
                    name="SelectedMOCWallThimble"
                    register={register({ required: true })}
                    errors={errors}
                    dataArray={[
                      { label: "Cast Iron", value: "Cast Iron" },
                      { label: "Stainless Steel", value: "Stainless Steel" },
                      { label: "Carbon Steel", value: "Carbon Steel" },
                    ]}
                    onChange={(val) => setMaterialOfConstruction(val)}
                    undefinedValue={true}
                    disabled={isViewFlag}
                  />
                )}

                {rnderRow(
                  "Quantity of anchor fasteners on Penstock",
                  "=",
                  <TeInput
                    name="quantityOfFasteners"
                    type="number"
                    onChange={(e) => setQuantityOfFastenrs(e.target.value)}
                    value={quantityOfFastenrs}
                    readOnly={isViewFlag}
                  />
                )}
                {rnderRow(
                  "Dia.of foundation bolts/ anchoring fasteners/chemical fasteners(d1)=",
                  "=",
                  <TeSelect
                    name="DiaOfBoltsWallThimble"
                    register={register({ required: true })}
                    errors={errors}
                    dataArray={[
                      { label: "12", value: 12 },
                      { label: "16", value: 16 },
                      { label: "20", value: 20 },
                      { label: "24", value: 24 },
                      { label: "30", value: 30 },
                    ]}
                    onChange={(val) => setDiaOfBolts(val)}
                    undefinedValue={true}
                    disabled={isViewFlag}
                  />
                )}
                {rnderRow(
                  "Length of foundation bolts/anchoring fasteners/chemical fasteners =",
                  "=",
                  checkForNull(lengthOfFoundationBolt())
                )}
                {rnderRow(
                  "Length to be embedded in concrete (le)",
                  "=",
                  <TeSelect
                    name="lengthEmbededConcrete"
                    register={register({ required: true })}
                    errors={errors}
                    dataArray={embededLengthConcreteOptions}
                    onChange={(val) => setEmbededLengthConcrete(val)}
                    undefinedValue={true}
                    disabled={isViewFlag}
                  />,
                  "mm"
                )}
                {rnderRow(
                  "The bolt will be embedded in minimum M30 Grade concrete,having",
                  "=",
                  ""
                )}
                {rnderRow("bonding strength of  (fb)", "=", bondingStrength)}
                {rnderRow(
                  "Hence, anchor bolt will have safe working force of resistance",
                  "=",
                  "Π x D1 x le x fb"
                )}
                {rnderRow("", "=", workingForceOFresistance.toFixed(2))}
                {rnderRow(
                  "Hence total no of anchor bolt required",
                  "=",
                  "Unseating/seating water force acting on frame / Safe working force of resisted each anchor bolt",
                  ""
                )}
                {rnderRow("", "=", <span>{checkForNull(totalNoOfAnchorBoltRequired).toFixed(0)}Nos.</span>)}
                <Row md="12">
                  <Col>
                    {totalNoOfAnchorBoltRequired < quantityOfFastenrs ? (
                      <b>
                        {
                          "Since load on each fastener is less than safe working force of resistance, the design is safe."
                        }
                      </b>
                    ) : (
                      <b>{<p className='error'>Design is Un-safe, Please re-design.</p>}</b>
                    )}
                  </Col>
                </Row>
              </div>
            ) : (
              <div>
                {renderHeading(
                  "8). The suitability of the selected bolts / fastener to fasten the frame to the wall Thimble"
                )}

                <Row className="mb-3">
                  <Col>
                    {
                      "We check for shearing of bolt thread of wall thimble at given unseating/seating water head"
                    }
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="5">
                    {"Unseating water force acting on frame"}
                  </Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{"Area x water head"}</Col>

                  <Col md="5">{""}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{"W x H x water head"}</Col>

                  <Col md="5">{""}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{forceActingOnFrame().toFixed(2)} Kgs.</Col>

                  <Col md="5">{""}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{finalForceActingOnFrame().toFixed(2)}</Col>
                </Row>

                <Row className="mb-3">
                  <Col md="5">{"Material of consruction of wall thimble"}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="2">
                    <TeSelect
                      name="MaterialOfConstruction"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "Cast Iron", value: "Cast Iron" },
                        { label: "Stainless Steel", value: "Stainless Steel" },
                        { label: "Carbon Steel", value: "Carbon Steel" },
                      ]}
                      onChange={(val) => setMaterialOfConstruction(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />
                  </Col>
                  <Col md="3">{"[if required]"}</Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">
                    {"Permissible Shear stress of selected material"}
                  </Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{permissibleShearStress()}</Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">{"Quantity of fasteners on wall thimble"}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5" className="max-width-container">
                    <TeInput
                      name="quantityOfFasteners"
                      register={register({ required: true })}
                      errors={errors}
                      type="number"
                      onChange={(e) => setQuantityOfFastenrs(e.target.value)}
                      value={quantityOfFastenrs}
                      readOnly={isViewFlag}
                    /> <span className="unit-display">Nos</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">{"Dia.of bolts / fasteners"}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5" className="max-width-container">
                    <TeSelect
                      name="DiaOfBoltsWallThimble"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "12", value: 12 },
                        { label: "16", value: 16 },
                        { label: "20", value: 20 },
                        { label: "24", value: 24 },
                        { label: "30", value: 30 },
                      ]}
                      onChange={(val) => setDiaOfBolts(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    /><span className="unit-display">mm</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">{"Length of bolts / fasteners"}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="3" className="max-width-container">
                    <TeSelect
                      name="LengthOfBoltsWallThimble"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "75", value: 75 },
                        { label: "90", value: 90 },
                        { label: "100", value: 100 },
                        { label: "110", value: 110 },
                        { label: "150", value: 150 },
                        { label: "200", value: 200 },
                        { label: "250", value: 250 },
                        { label: "300", value: 300 },
                        { label: "350", value: 350 },
                        { label: "400", value: 400 },
                      ]}
                      onChange={(val) => setLengthOfBoltOfWallTimble(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />

                  </Col>

                </Row>

                <Row className="mb-3">
                  <Col md="5">{"The load on each anchor fastener"}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">Ps/ {quantityOfFastenrs}</Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">{""}</Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">{loadOnEachAnchorFastner.toFixed(2)} kN</Col>
                </Row>

                <Row className="mb-3">
                  <Col md="5">
                    {"Thread pitch of selected anchor fasteners nut"}
                  </Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">
                    {threadPitchOfSelectedAnchorNutTappedHole().toFixed(2)}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="5">
                    {
                      "Permissible strength of each tapped hole subjected to thread shear"
                    }
                  </Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">
                    {"Π x (d1-pitch/2) x (0.8 x d1) x fs x 9.81 / 1000"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="5">
                    {"Therefore, Permissible shear strength of tapped hole"}
                  </Col>
                  <Col md="2" className='text-right'>{"="}</Col>
                  <Col md="5">
                    {permissiableShearStrengthOfTappedHole().toFixed(2)} {' KN'}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <b>
                      {finalForceActingOnFrame() / quantityOfFastenrs < (0.85 * permissiableShearStrengthOfTappedHole()) ?
                        "Since load on each tapped hole is less than safe working force of resistance, the design is safe."
                        :
                        "Design is Un-safe, Please re-design."
                      }
                    </b>
                  </Col>
                </Row>
              </div>
            )}

            {isSelectedThrustOnIsFrame || SelectedFrameLengthType === 'SHORT LENGTH' ? (
              <div>
                {renderHeading("9). The suitability of the selected bolts to fasten the actuating mechanism to the yoke:-")}
                <Row className="mb-3">
                  <Col>
                    {"The bolts/nuts have to withstand the thrust coming from the actuating mechanism."}
                  </Col>
                  <Col>
                    {"We check for shear of threads of bolt/nut securing the pillar to the floor due to load coming on it"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"Material of selected bolt / nut"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"4"} className="max-width-container">
                    <TeSelect
                      name="MaterialOfBoltForYoke"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "Stainless Steel", value: "Stainless Steel" },
                        { label: "Carbon Steel", value: "Carbon Steel" },
                      ]}
                      onChange={(val) => setMaterialOfSelectedBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>
                    {"Permissible shear stress of selected material"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"fs="}</Col>
                  <Col md={"4"}>{`${permissibleShearStressFS().toFixed(2)} Kgs./mm`}<sup>2</sup></Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"Diameter of bolts"}</Col>
                  <Col md={"2"} className='text-right'>{"d1="}</Col>
                  <Col md={"3"} className="max-width-container">
                    <TeSelect
                      name="DiameterOfBoltsForYoke"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "12", value: 12 },
                        { label: "16", value: 16 },
                        { label: "20", value: 20 },
                        { label: "24", value: 24 },
                        { label: "27", value: 27 },
                        { label: "30", value: 30 },
                      ]}
                      onChange={(val) => setDiameterOfBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    /> <span className="unit-display">mm</span></Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"Length of bolts"}</Col>
                  <Col md={"2"} className='text-right'>{"le="}</Col>
                  <Col md={"3"} className="max-width-container">
                    <TeSelect
                      name="LengthOfBoltsForYoke"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "75", value: 75 },
                        { label: "90", value: 90 },
                        { label: "100", value: 100 },
                        { label: "110", value: 110 },
                        { label: "125", value: 125 },
                        { label: "175", value: 175 },
                        { label: "200", value: 200 },
                        { label: "250", value: 250 },
                        { label: "300", value: 300 },
                        { label: "350", value: 350 },
                      ]}
                      onChange={(val) => setLengthOfBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    /><span className="unit-display">mm</span></Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"Quantity of bolt on pillar"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"3"} className="max-width-container">
                    <TeInput
                      name="quantityOfBolt"
                      register={register({ required: true })}
                      errors={errors}
                      type="number"
                      onChange={(e) => setQuantityOfBoltOnPillar(e.target.value)}
                      value={quantityOfBoltOnPillar}
                      readOnly={isViewFlag}
                    /><span className="unit-display">Nos</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"Total thrust load "}</Col>
                  <Col md={"2"} className='text-right'>{"P="}</Col>
                  <Col md={"5"}>{ratedThrustLoad().toFixed(2)} KN</Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{"The load on each fastener"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>Pr / {quantityOfBoltOnPillar}</Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>{""}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>{loadOnEachFastner.toFixed(2)} kN</Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>
                    {"Thread pitch of selected anchor fasteners nut"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>{threadPitchOfSelectedAnchorNut()} mm</Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>
                    {"Permissible strength of each nut subjected to thread shear"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>
                    {"Π x (d1-pitch/2) x (0.8 x d1) x fs x 9.81 / 1000"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={"5"}>
                    {"Therefore, Permissible shear strength of nut"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>
                    {permissibleShearStrengthOfNut().toFixed(2)} kN
                  </Col>
                </Row>
                <Row md="12">
                  <Col>
                    {permissibleShearStrengthOfNut() > loadOnEachFastner ? (
                      <b>
                        {
                          "Since permissible shear strength of nut is more than load acting on it, the design is safe."
                        }
                      </b>
                    ) : (
                      <b>{<p className='error'>Design is Un-safe, Please re-design.</p>}</b>
                    )}
                  </Col>
                </Row>
              </div>
            ) : (
              <div>
                {renderHeading(
                  "9). The suitability of the selected foundation bolts to fasten the floor pillar to the civils: -"
                )}
                {renderSingleColoumRow(
                  "The L/J bolts have to withstand the thrust coming from the actuating mechanism."
                )}
                {renderHeading(
                  "A. First we check for suitability of the selected foundation bolt to fasten the pillar to the civils: -"
                )}
                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Material of selected foundation bolt / nut"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>
                    <TeSelect
                      name="SelectedMaterialOfSelectedBolt"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "Stainless Steel", value: "Stainless Steel" },
                        { label: "Carbon Steel", value: "Carbon Steel" },
                      ]}
                      onChange={(val) => setMaterialOfSelectedBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />
                  </Col>
                  <Col md={"3"} className="cr-mm-dimension">

                  </Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Permissible shear stress of selected material fs"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"fs="}</Col>
                  <Col md={"5"}>{`${permissibleShearStressFS().toFixed(2)} Kgs./mm`}<sup>2</sup></Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>{"Diameter of foundation bolts"}</Col>
                  <Col md={"2"} className='text-right'>{"d1="}</Col>
                  <Col md={"2"}>
                    <TeSelect
                      name="SelectedDiameterOfBolt"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "12", value: 12 },
                        { label: "16", value: 16 },
                        { label: "20", value: 20 },
                        { label: "24", value: 24 },
                        { label: "27", value: 27 },
                        { label: "30", value: 30 },
                      ]}
                      onChange={(val) => setDiameterOfBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />
                  </Col>
                  <Col md={"3"}>{"mm"}</Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>{"Length of foundation bolts"}</Col>
                  <Col md={"2"} className='text-right'>{"le="}</Col>
                  <Col md={"2"}>{foundationBoltLength.toFixed(2)}{" mm"}</Col>

                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>{"Length to be embedded in concrete"}</Col>
                  <Col md={"2"} className='text-right'>{"le="}</Col>
                  <Col md={"2"}>
                    <TeSelect
                      name="SelectedLengthOfBolt"
                      register={register({ required: true })}
                      errors={errors}
                      dataArray={[
                        { label: "75", value: 75 },
                        { label: "90", value: 90 },
                        { label: "100", value: 100 },
                        { label: "110", value: 110 },
                        { label: "125", value: 125 },
                        { label: "125", value: 150 },
                        { label: "175", value: 175 },
                        { label: "200", value: 200 },
                        { label: "250", value: 250 },
                        { label: "300", value: 300 },
                        { label: "350", value: 350 },
                      ]}
                      onChange={(val) => setLengthOfBolt(val)}
                      undefinedValue={true}
                      disabled={isViewFlag}
                    />
                  </Col>
                  <Col md={"3"} className="cr-mm-dimension">
                    {"mm"}
                  </Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>{"Quantity of anchor bolt on pillar"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>
                    <TeInput
                      name="quantityOfBolt"
                      type="number"
                      onChange={(e) => setQuantityOfBoltOnPillar(e.target.value)}
                      value={quantityOfBoltOnPillar}
                      readOnly={isViewFlag}
                    />
                  </Col>
                  <Col md={"3"}>{"Nos"}</Col>
                </Row>
                {renderSingleColoumRow(
                  "The force required to pull the concrete apart is the shear strength of concrete (800 Psi) times the surface of the cone."
                )}

                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Anchor bolt has safe working force of resistance"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>800 x Π x 1.4142 x le<sup>2</sup></Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-2">
                  <Col md={"5"}>
                    {
                      "Therefore, the anchor bolt has safe working force of resistance"
                    }
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>{safeWorkingForceOFresistance().toFixed(0)}{" KN"}</Col>
                  <Col md={"3"}></Col>
                </Row>
                <Row md="12" className="mb-2">
                  <Col md={"5"}>{"Load on each anchor fastener"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>P / no. off bolts</Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-2">
                  <Col md={"5"}>{"Total thrust load "}</Col>
                  <Col md={"2"} className='text-right'>{"P="}</Col>
                  <Col md={"2"}>{ratedThrustLoad().toFixed(2)} KN</Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-2">
                  <Col md={"5"}>{"Therefore Thrust load on each fastener"}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>{checkForNull(thrustLoadOnEachFastner).toFixed(2)}{" KN"}</Col>
                  <Col md={"3"}></Col>
                </Row>
                <Row md="12" className="mb-2">
                  <Col>
                    {safeWorkingForceOFresistance() > thrustLoadOnEachFastner ? (
                      <b>
                        {
                          "Since load on each fastener is less than safe working force of resistance, the design is safe."
                        }
                      </b>
                    ) : (
                      <b>{<p className='error'>Design is Un-safe, Please re-design.</p>}</b>
                    )}
                  </Col>
                </Row>

                {renderHeading(
                  "B. Now we check for shear of threads of nut securing the pillar to the floor due to load coming on it :"
                )}
                <Row md="12" className="mb-3">
                  <Col md={"5"}>{"The load on each fastener    "}</Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>Pr/{parseInt(checkForNull(quantityOfBoltOnPillar)).toFixed(2)}</Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}></Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>{checkForNull(loadOnEachFastnerNut).toFixed(2)}</Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Thread pitch of selected anchor fasteners nut"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>
                    {threadPitchOfSelectedAnchorNut().toFixed(2)} mm
                  </Col>
                  <Col md={"3"}>{""}</Col>
                </Row>
                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Permissible strength of each nut subjected to thread shear"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"5"}>
                    {"Π x (d1-pitch/2) x (0.8 x d1) x fs x 9.81 / 1000 "}
                  </Col>
                </Row>

                <Row md="12" className="mb-3">
                  <Col md={"5"}>
                    {"Therefore, Permissible shear strength of nut"}
                  </Col>
                  <Col md={"2"} className='text-right'>{"="}</Col>
                  <Col md={"2"}>{permissibleShearStrengthOfNut().toFixed(2)}{" kN"}</Col>
                  <Col md={"3"}></Col>
                </Row>

                <Row md="12" className="mb-3">
                  <Col>
                    {permissibleShearStrengthOfNut() > loadOnEachFastnerNut ? (
                      <b>
                        {
                          "Since permissible shear strength of nut is more than load acting on it, the design is safe."
                        }
                      </b>
                    ) : (
                      <b>{<p className='error'>Design is Un-safe, Please re-design.</p>}</b>
                    )}
                  </Col>
                </Row>
              </div>
            )}

            <Row className="mb-2 mt-4">
              <Col md="12">
                <div className={"page-heads"}>
                  <b>
                    10). The allowable Standard leakage rate of Penstock under
                    maximum head conditions: -
                  </b>
                </div>
              </Col>
            </Row>

            <Row md="12" className="mb-2">
              <Col md={"5"}>
                {
                  "The maximum permissible leakage rates for the Penstock will be calculated from"
                }
              </Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"5"}>
                <TeSelect
                  name="SlideOrSluiceGateStandard"
                  register={register({ required: true })}
                  errors={errors}
                  dataArray={[
                    {
                      label: "BS7775 : 1995 standard for Sluice/Slide Gates",
                      value: "BS7775 : 1995 standard for Sluice/Slide Gates",
                    },
                    {
                      label: "BS7775 : 2005 standard for Sluice/Slide Gates",
                      value: "BS7775 : 2005 standard for Sluice/Slide Gates",
                    },
                    {
                      label: "AWWA C561 : standard for Sluice/Slide Gates",
                      value: "AWWA C561 : standard for Sluice/Slide Gates",
                    },
                    {
                      label: "AWWA C513 : standard for Sluice/Slide Gates",
                      value: "AWWA C513 : standard for Sluice/Slide Gates",
                    },
                    {
                      label: "AWWA C560 : standard for Sluice/Slide Gates",
                      value: "AWWA C560 : standard for Sluice/Slide Gates",
                    },
                    {
                      label: "IS 13349 : 1995 standard for Sluice/Slide Gates",
                      value: "IS 13349 : 1995 standard for Sluice/Slide Gates",
                    },
                    {
                      label: "As per tender specification/other/ as agreed",
                      value: "As per tender specification/other/ as agreed",
                    },
                  ]}
                  onChange={(val) => handleChange(val)}
                  undefinedValue={true}
                  disabled={isViewFlag}
                />
              </Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                <b>{"A1. For on seating head:"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"Less Than"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"6 Meter"}</b>
              </Col>
              <Col md={"3"}>{""}</Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                {
                  "Maximum allowable leakage (Liter /min./ meter of sealing perimeter)"
                }
              </Col>
              <Col md={"2"}>{onseatingHeadLessThan6Value}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>{onseatingHeadLessThan6Value}</Col>
            </Row>
            <Row className="mb-3">
              <Col md={"5"}>{""}</Col>
              <Col md={"2"}>{""}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>
                <TeInput
                  name="numberOfStarts"
                  register={register({ required: true })}
                  errors={errors}
                  type="number"
                  onChange={(e) => setOnSeatingLessThan6Leakae(e.target.value)}
                  value={onSeatingLessThan6Leakae}
                  readOnly={isViewFlag}
                />
              </Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                <b>{"A2. For on Off seating head:"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"Less Than"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"6 Meter"}</b>
              </Col>
              <Col md={"3"}>{""}</Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                {
                  "Maximum allowable leakage (Liter /min./ meter of sealing perimeter)"
                }
              </Col>
              <Col md={"2"}>{onOffSeatingHeadLessThan6Value}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>{onOffSeatingHeadLessThan6Value}</Col>
            </Row>
            <Row className="mb-3">
              <Col md={"5"}>{""}</Col>
              <Col md={"2"}>{""}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>
                <TeInput
                  name="numberOfStarts"
                  register={register({ required: true })}
                  errors={errors}
                  type="number"
                  onChange={(e) =>
                    setOnOffSeatingLessThan6Leakae(e.target.value)
                  }
                  value={onOffSeatingLessThan6Leakae}
                  readOnly={isViewFlag}
                />
              </Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                <b>{"B1. For on seating head :"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"Less Than"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"6 Meter"}</b>
              </Col>
              <Col md={"3"}>{""}</Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                {
                  "Maximum allowable leakage (Liter /min./ meter of sealing perimeter)"
                }
              </Col>
              <Col md={"2"}>{onseatingHeadMoreThan6Value}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>{onseatingHeadMoreThan6Value}</Col>
            </Row>
            <Row className="mb-3">
              <Col md={"5"}>{""}</Col>
              <Col md={"2"}>{""}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>
                <TeInput
                  name="numberOfStarts"
                  register={register({ required: true })}
                  errors={errors}
                  type="number"
                  onChange={(e) => setOnSeatingMoreThan6Leakae(e.target.value)}
                  value={onSeatingMoreThan6Leakae}
                  readOnly={isViewFlag}
                />
              </Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                <b>{"B2. For on Off seating head :"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"Less Than"}</b>
              </Col>
              <Col md={"2"}>
                <b>{"6 Meter"}</b>
              </Col>
              <Col md={"3"}>{""}</Col>
            </Row>

            <Row md="12">
              <Col md={"5"}>
                {
                  "Maximum allowable leakage (Liter /min./ meter of sealing perimeter)"
                }
              </Col>
              <Col md={"2"}>{onOffSeatingHeadMoreThan6Value}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>{onOffSeatingHeadMoreThan6Value}</Col>
            </Row>
            <Row className="mb-3">
              <Col md={"5"}>{""}</Col>
              <Col md={"2"}>{""}</Col>
              <Col md={"2"} className='text-right'>{"="}</Col>
              <Col md={"3"}>
                <TeInput
                  name="numberOfStarts"
                  register={register({ required: true })}
                  errors={errors}
                  type="number"
                  onChange={(e) =>
                    setOnOffSeatingMoreThan6Leakae(e.target.value)
                  }
                  value={onOffSeatingMoreThan6Leakae}
                  readOnly={isViewFlag}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <b>{"For on seating head"}</b>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Gate size (W x H) in m"}</Col>
              <Col md="2">{widthInMeter.toFixed(2)} m Width</Col>
              <Col md="5">{heightInMeter.toFixed(2)} m Height</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Sealing perimeter in m"}</Col>
              <Col md="2">{sealingPerimeter.toFixed(2)}</Col>
              <Col md="5">{""}</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Seating Head in m"}</Col>
              <Col md="2">{intSeatingHead}</Col>
              <Col md="5">{""}</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Hence, permissible leakage"}</Col>
              <Col md="2">{permissibleLeakageSeatingHead.toFixed(2)}</Col>
              <Col md="5">
                {"Liter per min. per meter of sealing perimeter"}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{""}</Col>
              <Col md="2">
                {permissibleLeakageSeatingHeadIntoGallon.toFixed(2)}
              </Col>
              <Col md="5">
                {"Gallons per min. per feet of sealing perimeter	"}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Permissible leakage for seating head"}</Col>
              <Col md="2">{finalSeatingHeadPermissibleLeakage.toFixed(2)}{" Liter/minute ="}</Col>
              <Col md="5">
                {finalSeatingHeadPermissibleLeakageIntoGallon.toFixed(2)}{" Gallons/minute"}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="12">
                <b>{"For off seating head"}</b>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Gate size (W x H) in m ="}</Col>
              <Col md="2">{widthInMeter.toFixed(2)}{" m Width"}</Col>
              <Col md="5">{heightInMeter.toFixed(2)}{" m Height"}</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Sealing perimeter in m ="}</Col>
              <Col md="5">{sealingPerimeter.toFixed(2)}</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Off Seating Head in m"}</Col>
              <Col md="5">{checkForNull(intUnseatingHead).toFixed(2)}</Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{"Hence, permissible leakage"}</Col>
              <Col md="2">{permissibleLeakageUnSeatingHead.toFixed(2)}</Col>
              <Col md="5">
                {"Liter per min. per meter of sealing perimeter "}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">{""}</Col>
              <Col md="2">
                {permissibleLeakageUnSeatingHeadIntoGallon.toFixed(2)}
              </Col>
              <Col md="5">
                {"Gallons per min. per feet of sealing perimeter	"}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md="5">
                <b>{"Permissible leakage for unseating head"}</b>
              </Col>
              <Col md="2">
                <b>{finalUnSeatingHeadPermissibleLeakage.toFixed(2)}{" Liter/minute ="}</b>
              </Col>

              <Col md="5">
                <b>
                  {finalUnSeatingHeadPermissibleLeakageIntoGallon.toFixed(2)}{" Gallons/minute"}
                </b>
              </Col>
            </Row>

            {/* <Row className="mb-2 mt-4">
                            <Col md="12">
                                <div className={'page-heads'}>
                                    <b>11). Design of Yoke: -</b>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="12">
                                The yoke is designed as a a simply supported beam with concentrated load at axis
                                of spindle. For this condition the deflection of yoke shall not be greater
                                than L/360 or a maximum of 6.4 mm at maximum operating load.
                                For design of yoke we consider maximum force that can come due to stalling
                                of actuator or the maximum effort applied by operator.
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="8">
                                <Row className="mb-3">
                                    <Col md="8">
                                        {'Material of construction of Yoke'}
                                    </Col>
                                    <Col md="4">
                                        <TeSelect
                                            name='MaterialOfConstructionYoke'
                                            register={register({required: true})}
          errors={errors}
                                            dataArray={[
                                                { label: 'Stainless Steel', value: 'Stainless Steel' },
                                                { label: 'Carbon Steel', value: 'Carbon Steel' },
                                                { label: 'Aluminum Steel', value: 'Aluminum Steel' },
                                            ]}
                                            onChange={(val) => setConstructionMaterialOfYoke(val)}
                                        />
                                    </Col>

                                    <Col md="8">
                                        {'We consider yoke section ='}
                                    </Col>
                                    <Col md="4">
                                        <TeSelect
                                            name='YokeSection'
                                            register={register({required: true})}
          errors={errors}
                                            dataArray={[
                                                { label: 'A', value: 'A' },
                                                { label: 'B', value: 'B' },
                                                { label: 'C', value: 'C' },
                                            ]}
                                            onChange={(val) => setYokeSection(val)}
                                        />
                                    </Col>

                                    <Col md="12">
                                        {'Where, '}
                                    </Col>

                                    <Col md="1">
                                        {'H'}
                                    </Col>
                                    <Col md="2">
                                        {section11VaueOfH()}
                                    </Col>
                                    <Col md="9">
                                        {'mm'}
                                    </Col>

                                    <Col md="1">
                                        {'P'}
                                    </Col>
                                    <Col md="2">
                                        {section11VaueOfP()}
                                    </Col>
                                    <Col md="9">
                                        {'mm'}
                                    </Col>

                                    <Col md="1">
                                        {'Q'}
                                    </Col>
                                    <Col md="2">
                                        {section11VaueOfQ()}
                                    </Col>
                                    <Col md="9">
                                        {'mm'}
                                    </Col>

                                    <Col md="5">
                                        {'We consider thickness of section '}
                                    </Col>
                                    <Col md="2">
                                        {<TeSelect
                                            name='ThicknessOfSection'
                                            register={register({required: true})}
          errors={errors}
                                            dataArray={[
                                                { label: '4', value: 4 },
                                                { label: '5', value: 5 },
                                                { label: '6', value: 6 },
                                                { label: '8', value: 110 },
                                                { label: '10', value: 125 },
                                                { label: '12', value: 12 },
                                            ]}
                                            onChange={(val) => setThicknessOfSection(val)}
                                        />}
                                    </Col>
                                    <Col md="5">
                                        {'mm'}
                                    </Col>

                                </Row>
                            </Col>
                            <Col md="4">
                                {<img src={require('../../assests/images/yokeImage.png')} />}
                            </Col>

                        </Row>

                        <Row className="mb-3">
                            <Col md="6">
                                {'Max. deflection at the centre = '}
                            </Col>
                            <Col md="6">
                                {'W x L3 / (48 x E x I)'}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="12">
                                {'Where,'}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="1">
                                {'W'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="8">
                                {'Force due to stalling / maximum effort of operator or Hoisting Force whichever is higher'}
                            </Col>
                            <Col md="2">
                                {calculateValueOfW()} N
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="1">
                                {'L'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="8">
                                {'Length of span = ( Length of Yoke + 150 mm)	'}
                            </Col>
                            <Col md="2">
                                {lengthOfSpan} mm
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="1">
                                {'E'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="8">
                                {'Modulus of elasticity of selected material ='}
                            </Col>
                            <Col md="2">
                                {modulusOfElasticityOfSelectedMaterial()} N/mm2
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="1">
                                {'I'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="8">
                                {'Moment of Inertia for selected section ='}
                            </Col>
                            <Col md="2">
                                {momentOfInertia} mm4
                            </Col>
                        </Row>


                        <Row className="mb-3">
                            <Col md="6">
                                {'Max. deflection at the centre '}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="5">
                                {
                                    shaftSpindle === 'SINGLE_SPINDLE' ?
                                        'W x L3 / (48 x E x I)'
                                        :
                                        'W x a ( 3 x L^2 - 4 x a^2 ) / ( 24 x E x I )'
                                }
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="6">
                                {'Therefore, Max. deflection at the centre'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="5">
                                {maxDeflectionAtCenter} mm
                            </Col>
                        </Row>


                        <Row className="mb-3">
                            <Col md="12">
                                {'The allowable deflection of Yoke =	Span / L '}
                            </Col>

                            <Col md="6">
                                {''}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="5">
                                {'( W + 150 )/ L'}
                            </Col>

                            <Col md="6">
                                {'Where,'}
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="2">
                                <TeInput
                                    name='L'
                                    register={register({required: true})}
          errors={errors}
                                    type='number'
                                    onChange={(e) => setValueOfLSection11(e.target.value)}
                                    value={valueOfLSection11}
                                />
                            </Col>
                            <Col md="3">
                                {'mm'}
                            </Col>

                        </Row>

                        <Row className="mb-3">
                            <Col md="6">
                                <b> {'Hence,The allowable deflection of Yoke'}</b>
                            </Col>
                            <Col md="1">
                                {'='}
                            </Col>
                            <Col md="2">
                                {allowableDeflectionOfYoke.toFixed(2)}
                            </Col>
                            <Col md="3">
                                {'mm'}
                            </Col>
                        </Row>

                        <Row md="12">
                            <Col>
                                {allowableDeflectionOfYoke > maxDeflectionAtCenter ?
                                    <b>{'Since maximum deflection of yoke is less than permissible deflection as per AWWA, the design is safe.'}</b>
                                    :
                                    <b>{<p className = 'error'>Design is Un-safe, Please re-design.</p>}</b>
                                }
                            </Col>
                        </Row>*/}
          </p>
          <hr className={"my-4"} />
          {!isViewFlag && <div className={"text-right my-2"}>
            <button className={"btn btn-primary"} type="submit">
              Submit
            </button>
          </div>}
        </form>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  const returnObj = {};
  const electricalData = state.desingMster.electricSectionData;

  const {
    ClPl,
    Client,
    Dated,
    Location,
    Project,
    RevisionDate,
    RevisionNumber,
    SeatingHead,
    SelectedClosureType,
    SelectedFrameLengthType,
    SelectedFrameMounting,
    SelectedSeriesOffered,
    SelectedSpindleDirection,
    SelectedStemDiameter,
    SelectedStemMaterial,
    SelectedThrustOn,
    SizeHeight,
    SizeWidth,
    SkinPlateThickness,
    TagNumber,
    UnseatingHead,
    SelectedSpindleType,
  } = electricalData

  returnObj.data = {
    height: SizeHeight,
    seatingHead: SeatingHead,
    unseatingHead: UnseatingHead,
    width: SizeWidth,
    stemDia: SelectedStemDiameter,
    cl_pl: ClPl,
    shaftSpindle: SelectedSpindleType,
    SpindleDirection: SelectedSpindleDirection,
    frameMounting: SelectedFrameMounting,
    ClosureType: SelectedClosureType,
    SelectedSeriesOffered: SelectedSeriesOffered,
    skinPlateThickness: SkinPlateThickness,
    date: Dated,
    client: Client,
    project: Project,
    location: Location,
    tag_number: TagNumber,
    rev_number: RevisionNumber,
    rev_date: RevisionDate,
    selectedThrustOn: SelectedThrustOn,
    SelectedFrameLengthType: SelectedFrameLengthType,
    stemMaterial: SelectedStemMaterial
  }

  return returnObj;
}

export default connect(mapStateToProps, {
  saveElectricalData,
  getElectricShutterData,
  updateElectricGate,
})(ElectricallyGates);
